<template>
  <el-container>
    <el-container>
      <div class="detail-body">
        <div class="Ecard w-100" id="trendChart">
          <div class="testMain">
            <div>
              <!-- 过滤 -->
              <el-form :inline="true" size="mini" class="spacForm">
                <el-form-item label="日期">
                  <el-select
                    v-model="date"
                    @change="
                      onFormItemChange($event, 'date', [
                        'test_id',
                        'records',
                        'device',
                        'scene'
                      ])
                    "
                  >
                    <el-option
                      v-for="(item, k) in date_list"
                      :key="k"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="test_id">
                  <el-select
                    v-model="record_id"
                    @change="
                      onFormItemChange($event, 'record_id', [
                        'records',
                        'device',
                        'scene'
                      ])
                    "
                  >
                    <el-option
                      v-for="(item, k) in record_list"
                      :key="k"
                      :label="item.name"
                      :value="item.record_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="memory_width_selec"
                  label="新版本"
                >
                  <el-select
                    v-model="version"
                    @change="
                      onFormItemChange($event, 'version', ['device', 'scene'])
                    "
                  >
                    <el-option
                      v-for="(item, k) in sceneList"
                      :key="k"
                      :label="item.version"
                      :value="item.version"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item class="memory_width_selec" label="设备">
                  <el-select
                    v-model="device_id"
                    @change="onFormItemChange($event, 'device_id', ['scene'])"
                  >
                    <el-option
                      v-for="(item, k) in device_list"
                      :key="k"
                      :label="item.device__model__name"
                      :value="item.device_id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item class="memory_width_selec" label="场景">
                  <el-select
                    v-model="scene_name"
                    @change="onFormItemChange($event, 'scene_name', [])"
                  >
                    <el-option
                      v-for="(item, k) in scene_list"
                      :key="k"
                      :label="
                        item.scene_name + (item.remark ? '-' + item.remark : '')
                      "
                      :value="item.scene_name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="success" @click="confirm()"
                    >筛选所选场景</el-button
                  >
                </el-form-item>
                <el-form-item label="">
                  <el-button type="danger" @click="deleteBtn()"
                    >删除所选数据</el-button
                  >
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" @click="downSource">下载源数据</el-button>
                </el-form-item>
              </el-form>
              <el-form :inline="true" size="mini" class="spacForm">
                <el-form-item label="日期">
                  <el-select
                    v-model="old_date"
                    @change="
                      onFormItemChange(
                        $event,
                        'old_date',
                        ['test_id', 'records', 'device', 'scene'],
                        true
                      )
                    "
                  >
                    <el-option
                      v-for="(item, k) in date_list"
                      :key="k"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="test_id">
                  <el-select
                    v-model="record_id_old"
                    @change="
                      onFormItemChange(
                        $event,
                        'record_id_old',
                        ['records', 'device', 'scene'],
                        true
                      )
                    "
                  >
                    <el-option
                      v-for="(item, k) in record_list_old"
                      :key="k"
                      :label="item.name"
                      :value="item.record_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="memory_width_selec"
                  label="旧版本"
                >
                  <el-select
                    v-model="old_version"
                    @change="
                      onFormItemChange(
                        $event,
                        'old_version',
                        ['device', 'scene'],
                        true
                      )
                    "
                  >
                    <el-option
                      v-for="(item, k) in sceneOldList"
                      :key="k"
                      :label="item.version"
                      :value="item.version"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item class="memory_width_selec" label="设备">
                  <el-select
                    v-model="device_id_old"
                    @change="
                      onFormItemChange($event, 'device_id_old', ['scene'], true)
                    "
                  >
                    <el-option
                      v-for="(item, k) in device_list_old"
                      :key="k"
                      :label="item.device__model__name"
                      :value="item.device_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="memory_width_selec" label="场景">
                  <el-select
                    v-model="scene_name_old"
                    @change="
                      onFormItemChange($event, 'scene_name_old', [], true)
                    "
                  >
                    <el-option
                      v-for="(item, k) in scene_list_old"
                      :key="k"
                      :label="
                        item.scene_name + (item.remark ? '-' + item.remark : '')
                      "
                      :value="item.scene_name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" @click="submitUpload('open')"
                    >上传原始文件</el-button
                  >
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" @click="submitUpload_result('open')"
                    >上传结果文件</el-button
                  >
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" size="mini" @click="saveCurLink">保存链接</el-button>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" size="mini" @click="toOverview">内存资源概览</el-button>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" size="mini" @click="uploadOriginFile">上传原始文件New</el-button>
                </el-form-item>
                <!-- <el-form-item label="">
                  <el-button type="primary" @click="openConfig('open')"
                    >阈值配置</el-button
                  >
                </el-form-item> -->
              </el-form>
            </div>
            <!-- 手动生成报告弹窗-按任务 -->

            <!-- 手动生成报告弹窗 -->

            <!-- 版本 -->

            <!-- 版心 -->

            <div class="spacName">
              <h5 id="all_scroll" class="TitleStyle"><span></span>资源汇总</h5>
              <h6
                style="display: flex; align-items: center; margin: 8px 0 8px 0">
                <span class="subTitle">◆</span>
                统计数据
              </h6>
              <el-form :inline="true" size="mini">
                <el-form-item label="变化值">
                  <div class="d-flex">
                    <el-input
                      @input="saveToLocalStorageData({tableDataKey: 'mem_list'})"
                      class="w-100px"
                      v-model="change_size"></el-input>
                    <span class="ms-1">MB</span>
                  </div>
                </el-form-item>
              </el-form>
              <el-table
                style="margin-top: 20px"
                size="mini"
                border
                v-loading="mem_loading"
                :header-cell-style="{
                  background: '#5D99D5',
                  color: '#fff'
                }"
                row-key="rowKey"
                :data="mem_list">
                <el-table-column align="center" label="类别">
                  <template #default="scope">
                    {{ scope.row.module }}
                  </template>
                </el-table-column>
                <el-table-column label="当前版本">
                  <template #default="scope">
                    <span>{{ scope.row.new }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="对比版本">
                  <template #default="scope">
                    {{ scope.row.old }}
                  </template>
                </el-table-column>
                <el-table-column label="变化值">
                  <template #default="scope">
                    <span
                      :style="
                        getColor_config_size(scope.row.diff_value, change_size)
                      "
                      >{{ scope.row.diff }}</span
                    >
                  </template>
                </el-table-column>
              </el-table>

              <h6
                style="display: flex; align-items: center; margin: 8px 0 8px 0">
                <span class="subTitle">◆</span>
                数据占比
              </h6>

              <div
                style="display: flex"
                v-loading="resLoading"
                class="spacName">
                <div id="res" style="width: 41.62%; height: 360px"></div>
                <div style="width: 58.38%">
                  <el-table
                    border
                    size="mini"
                    :header-cell-style="{
                      background: '#f5f7fa'
                    }"
                    @sort-change="sort_change"
                    :cell-style="cellStyle"
                    :data="res_detail_table">
                    <el-table-column label="模块" prop="name"></el-table-column>
                    <el-table-column
                      width="100"
                      prop="size"
                      label="内存"
                      sortable="custom"
                    >
                      <template #default="scope">
                        {{ scope.row["内存"] }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="rate"
                      width="80"
                      label="占比"
                      sortable="custom"
                    >
                      <template #default="scope">
                        {{ scope.row["占比"] }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="change"
                      width="80"
                      label="变化"
                      sortable="custom"
                    >
                      <template #default="scope">
                        {{ scope.row["变化"] }}
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-footer style="padding: 5px 0px; text-align: right">
                    <el-form :inline="true" size="mini">
                      <el-form-item style="margin-bottom: 0">
                        <el-pagination
                          v-model:currentPage="currentPage"
                          :page-size="size"
                          layout="total, prev, pager, next, jumper"
                          :total="(resData.top_list || []).length"
                          @current-change="res_current_change"
                        ></el-pagination>
                      </el-form-item>
                    </el-form>
                  </el-footer>
                </div>
              </div>
              <el-card v-loading="res_loading">
                <div style="height: 500px" id="res_trend"></div>
              </el-card>

              <div class="spacName">
                <h5 class="TitleStyle"><span></span>资源总览</h5>
                <el-form :inline="true" size="mini">
                  <el-form-item label="变化值大小">
                    <div class="d-flex">
                      <el-input
                        @input="saveToLocalStorageData({tableDataKey: 'memory_detail_list'})"
                        v-model="resources.change_size"
                        class="w-100px"
                      ></el-input>
                      <span class="ms-1">MB</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="变化值数量">
                    <el-input
                      @input="saveToLocalStorageData({tableDataKey: 'memory_detail_list'})"
                      v-model="resources.change_count"
                      class="w-100px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="原始值大小">
                    <div class="d-flex">
                      <el-input
                        @input="saveToLocalStorageData({tableDataKey: 'memory_detail_list'})"
                        v-model="resources.size"
                        class="w-100px"
                      ></el-input>
                      <span class="ms-1">MB</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="原始值数量">
                    <el-input
                      @input="saveToLocalStorageData({tableDataKey: 'memory_detail_list'})"
                      v-model="resources.count"
                      class="w-100px"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <el-table
                  size="mini"
                  border
                  :header-cell-style="{
                    background: '#5D99D5',
                    color: '#fff'
                  }"
                  @sort-change="sort_change_v1"
                  v-loading="momory_loading_v1"
                  row-key="rowKey"
                  :data="
                    (memory_detail_list || []).slice(
                      (res_page_v1 - 1) * res_size_v1,
                      res_page_v1 * res_size_v1
                    )
                  ">
                  <el-table-column label="测试时间和案例">
                    <template #default="scope">
                      <span>{{ scope.row.module }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="当前版本">
                    <template #default="scope">
                      <span>
                        <template v-if="scope.row.new.includes('—')">
                          <div
                            style="cursor: pointer"
                            @click="scroll_detail(scope.row.module)"
                          >
                            <span
                              :style="
                                getColor_config_size(
                                  scope.row.new_value,
                                  resources.size
                                )
                              "
                              >{{ scope.row.new.split("—")[0] }}</span
                            >—<span
                              :style="
                                getColor_config_count(
                                  scope.row.count,
                                  resources.count
                                )
                              "
                              >{{ scope.row.new.split("—")[1] }}</span
                            >
                          </div>
                        </template>
                        <template v-else>
                          <div
                            style="cursor: pointer"
                            @click="scroll_detail(scope.row.module)"
                          >
                            <div v-if="scope.row.new.includes(',')">
                              <span
                                :style="
                                  getColor_config_size(
                                    scope.row.new_value,
                                    resources.size
                                  )
                                "
                                >{{ scope.row.new.split(",")[0] }}</span
                              >,<span>{{ scope.row.new.split(",")[1] }}</span>
                            </div>
                            <div
                              v-else
                              :style="
                                getColor_config_size(
                                  scope.row.new_value,
                                  resources.size
                                )
                              "
                            >
                              {{ scope.row.new }}
                            </div>
                          </div>
                        </template>
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="对比版本">
                    <template #default="scope">
                      <span>
                        <template v-if="scope.row.old.includes('—')">
                          <span>{{ scope.row.old.split("—")[0] }}</span
                          >—<span>{{ scope.row.old.split("—")[1] }}</span>
                        </template>
                        <template v-else>
                          {{ scope.row.old }}
                        </template>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="size_diff"
                    sortable="custom"
                    label="变化值"
                  >
                    <template #default="scope">
                      <span>
                        <template v-if="scope.row.diff.includes('—')">
                          <span
                            :style="
                              getColor_config_size(
                                scope.row.size_diff,
                                resources.change_size
                              )
                            "
                            >{{ scope.row.diff.split("—")[0] }}</span
                          >—<span
                            :style="
                              getColor_config_count(
                                scope.row.count_diff,
                                resources.change_count
                              )
                            "
                            >{{ scope.row.diff.split("—")[1] }}</span
                          >
                        </template>
                        <template v-else-if="scope.row.diff.includes(',')">
                          <span
                            :style="
                              getColor_config_size(
                                scope.row.size_diff,
                                resources.change_size
                              )
                            "
                            >{{ scope.row.diff.split(", ")[0] }}</span
                          >
                          , <span>{{ scope.row.diff.split(", ")[1] }}</span>
                        </template>
                        <!-- 默认情况 -->
                        <template v-else>
                          <span
                            :style="
                              getColor_config_size(
                                scope.row.size_diff,
                                resources.change_size
                              )
                            "
                            >{{ scope.row.diff }}</span
                          >
                        </template>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-form
                  :inline="true"
                  size="mini"
                  class="spacName"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: end;
                  "
                >
                  <el-form-item label="每页" class="mb-0">
                    <el-input
                      v-model="res_size_v1"
                      style="width: 55px; height: 28px"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="条记录" class="mb-0"></el-form-item>
                  <el-form-item style="margin-bottom: 0">
                    <el-pagination
                      v-model:currentPage="res_page_v1"
                      :page-size="res_size_v1"
                      layout="total, prev, pager, next, jumper"
                      :total="(memory_detail_list || []).length"
                    ></el-pagination>
                  </el-form-item>
                </el-form>
              </div>
              <div class="spacName">
                <h5 id="detail_scroll" class="TitleStyle">
                  <span></span>资源详情
                </h5>
                <el-form :inline="true" size="mini">
                  <el-form-item label="资源类型">
                    <el-select
                      v-model="fileName"
                      @change="fileChange"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in memoryFileList"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>

                <h6
                  style="
                    display: flex;
                    align-items: center;
                    margin: 8px 0 8px 0;
                  ">
                  <span class="subTitle">◆</span>
                  统计数据
                </h6>
                <el-table
                  size="mini"
                  border
                  v-loading="fileLoading"
                  :span-method="objectSpanMethod"
                  :header-cell-style="{
                    background: '#5D99D5',
                    color: '#fff'
                  }"
                  :data="file_table_list">
                  <el-table-column align="center" label="">
                    <template #default="scope">
                      <span>{{ scope.row.text }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="版本号">
                    <template #default="scope">
                      <span>{{ scope.row.version }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="资源大小">
                    <template #default="scope">
                      <span>{{ scope.row.sum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="资源数量">
                    <template #default="scope">
                      <span>{{ scope.row.top }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="平均大小">
                    <template #default="scope">
                      <span
                        :style="
                          'color:' +
                          (scope.row.text == '对比数据'
                            ? scope.row.proportion == '低风险'
                              ? '#00b050'
                              : 'red'
                            : '')
                        "
                        >{{ scope.row.proportion }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <h6
                  style="
                    display: flex;
                    align-items: center;
                    margin: 8px 0 8px 0;
                  ">
                  <span class="subTitle">◆</span>
                  数据占比
                </h6>
                <div
                  style="display: flex"
                  v-loading="fileLoading"
                  class="spacName">
                  <div id="file" style="width: 41.62%; height: 360px"></div>
                  <div style="width: 58.38%">
                    <el-table
                      border
                      size="mini"
                      :header-cell-style="{
                        background: '#f5f7fa'
                      }"
                      @sort-change="file_sort_change"
                      :cell-style="cellStyle"
                      :data="file_detail_table"
                    >
                      <el-table-column
                        label="模块"
                        prop="name"
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="size"
                        label="内存"
                        sortable="custom"
                      >
                        <template #default="scope">
                          {{ scope.row["内存"] }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="rate"
                        width="80"
                        label="占比"
                        sortable="custom"
                      >
                        <template #default="scope">
                          {{ scope.row["占比"] }}
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop="change"
                        width="80"
                        label="变化"
                        sortable="custom"
                      >
                        <template #default="scope">
                          {{ scope.row["变化"] }}
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-footer style="padding: 5px 0px; text-align: right">
                      <el-form :inline="true" size="mini">
                        <el-form-item style="margin-bottom: 0">
                          <el-pagination
                            v-model:currentPage="file_currentPage"
                            :page-size="file_size"
                            layout="total, prev, pager, next, jumper"
                            :total="(fileData.top_list || []).length"
                            @current-change="file_current_change"
                          ></el-pagination>
                        </el-form-item>
                      </el-form>
                    </el-footer>
                  </div>
                </div>
                <el-card v-loading="memory_loading">
                  <div style="height: 500px" id="file_trend"></div>
                </el-card>
                <h6
                  style="
                    display: flex;
                    align-items: center;
                    margin: 8px 0 8px 0;">
                  <span class="subTitle">◆</span>
                  详细数据
                </h6>
                <el-form :inline="true" size="mini">
                  <el-form-item label="变化值大小">
                    <div class="d-flex">
                      <el-input
                        @input="saveToLocalStorageData({tableDataKey: 'summaryList'})"
                        v-model="detail.change_size"
                        class="w-100px"
                      ></el-input>
                      <span class="ms-1">MB</span>
                    </div>
                    
                  </el-form-item>
                  <el-form-item label="变化值数量">
                    <el-input
                      @input="saveToLocalStorageData({tableDataKey: 'summaryList'})"
                      v-model="detail.change_count"
                      class="w-100px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="原始值大小">
                    <div class="d-flex">
                      <el-input
                        @input="saveToLocalStorageData({tableDataKey: 'summaryList'})"
                        v-model="detail.size"
                        class="w-100px"
                      ></el-input>
                      <span class="ms-1">MB</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="原始值数量">
                    <el-input
                      @input="saveToLocalStorageData({tableDataKey: 'summaryList'})"
                      v-model="detail.count"
                      class="w-100px"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="类别资源">
                    <el-input
                      @input="saveToLocalStorageData({tableDataKey: 'summaryList'})"
                      v-model="detailType"
                      class=""
                      placeholder="搜索"
                    ></el-input>
                  </el-form-item>
                </el-form>

                <!-- <pre>
                  {{ detailTableData }}
                </pre> -->
                <el-table
                  border
                  class="res_list"
                  size="mini"
                  :header-cell-style="{
                    background: '#5D99D5',
                    color: '#fff'
                  }"
                  v-loading="fileLoading"
                  :data="detailTableData"
                  @sort-change="onDetailSortChange">
                  <el-table-column
                    label="类别资源"
                    prop="name"
                    fixed="left"
                    min-width="350"
                  ></el-table-column>
                  <el-table-column min-width="620" prop="size" label="当前版本">
                    <template #default="scope">
                      <div :key="Math.random()" style="display: flex">
                        <span
                          class="memory_margin_row"
                          :style="sameSizeCount(scope.row.change, 'size')"
                          >大小:<span
                            :style="
                              getColor_config_size(scope.row.size, detail.size)
                            "
                            >{{ scope.row["内存"] }}</span
                          ></span
                        >
                        <span
                          class="memory_margin_row_count"
                          :style="sameSizeCount(scope.row.diff_count, 'count')"
                          >数量:<span
                            :style="
                              getColor_config_count(
                                scope.row.count,
                                detail.count
                              )
                            "
                            >{{ scope.row.count }}</span
                          ></span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.Width, scope.row.old.Width)"
                          >Width:{{ scope.row.Width }}</span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.Height, scope.row.old.Height)"
                          >Height:{{ scope.row.Height }}</span
                        >
                        <span
                          class="memory_margin_Format"
                          :style="same(scope.row.Format, scope.row.old.Format)"
                          >Format:{{ scope.row.Format }}</span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.MipMap, scope.row.old.MipMap)"
                          >MipMap:{{ scope.row.MipMap }}</span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.ISRead, scope.row.old.ISRead)"
                          >ISRead:{{ scope.row.ISRead }}</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="520" label="对比版本">
                    <template #default="scope">
                      <div style="display: flex">
                        <span
                          class="memory_margin_row"
                          :style="sameSizeCount(scope.row.change, 'size')"
                          >大小:<span :style="getColor_1(scope.row.change)">{{
                            scope.row.old["内存"]
                          }}</span></span
                        >
                        <span
                          class="memory_margin_row_count"
                          :style="sameSizeCount(scope.row.diff_count, 'count')"
                          >数量:<span
                            :style="getCount_10(scope.row.diff_count)"
                            >{{ scope.row.old.count }}</span
                          ></span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.Width, scope.row.old.Width)"
                          >Width:{{ scope.row.old.Width }}</span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.Height, scope.row.old.Height)"
                          >Height:{{ scope.row.old.Height }}</span
                        >
                        <span
                          class="memory_margin_Format"
                          :style="same(scope.row.Format, scope.row.old.Format)"
                          >Format:{{ scope.row.old.Format }}</span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.Format, scope.row.old.Format)"
                          >MipMap:{{ scope.row.old.MipMap }}</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="180" label="变化值" prop="change" sortable="custom">
                    <template #default="scope">
                      <div :key="Math.random()" style="display: flex">
                        <div class="margin_div">
                          <div>
                            大小:

                            <span
                              :style="
                                getColor_config_size(
                                  scope.row.change,
                                  detail.change_size
                                )
                              "
                              >{{
                                formattedChange(scope.row.change, true)
                              }}</span
                            >
                          </div>
                        </div>
                        <div class="margin_div">
                          <div>
                            数量:

                            <span
                              :style="
                                getColor_config_count(
                                  scope.row.diff_count,
                                  detail.change_count
                                )
                              "
                              >{{
                                formattedChange(scope.row.diff_count, false)
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column align="center" width="55" label="Detail">
                         <template #default="scope">
                        <span style="color: blue; cursor: pointer;" @click="checkBtn(scope.row.name)">查看</span>
                         </template>
                      </el-table-column> -->
                </el-table>

                <el-dialog
                  v-model="tableAddShow"
                  width="50%"
                  class="custom-dialog"
                  height="auto">
                  <el-table
                    size="mini"
                    border
                    :header-cell-style="{
                      background: '#5D99D5',
                      color: '#fff'
                    }"
                    :data="checkTable">
                    <el-table-column
                      label="类别资源"
                      prop="name"
                      width="300"
                    ></el-table-column>
                    <el-table-column
                      width="300"
                      prop="size"
                      :label="item.version"
                      v-for="item in checkCol"
                      :key="item"
                    >
                      <template #default="scope">
                        {{
                          getVersion(scope.row, item)
                        }}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-dialog>
                
                <el-form
                  :inline="true"
                  size="mini"
                  class="spacName"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: end;
                  ">
                  <el-form-item label="每页" class="mb-0">
                    <el-input
                      v-model="file_record"
                      style="width: 55px; height: 28px"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="条记录" class="mb-0"></el-form-item>
                  <el-form-item style="margin-bottom: 0">
                    <el-pagination
                      v-model:currentPage="file_page"
                      :page-size="file_record"
                      layout="total, prev, pager, next, jumper"
                      :total="(filterSummaryList || []).length"
                    ></el-pagination>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="(mod_data || []).length > 0" class="spacName">
                <h5 id="class_scroll" class="TitleStyle">
                  <span></span>资源分类
                </h5>
                <h6
                  style="
                    display: flex;
                    align-items: center;
                    margin: 8px 0 8px 0;
                  "
                >
                  <span class="subTitle">◆</span>
                  统计数据
                </h6>
                <el-form :inline="true" size="mini">
                  <el-form-item label="变化值大小">
                    <div class="d-flex">
                      <el-input
                        @input="saveToLocalStorageData({tableDataKey: 'mod_data'})"
                        v-model="resources_class.change_size"
                        class="w-100px"
                      ></el-input>
                      <span class="ms-1">MB</span>
                    </div>
                  </el-form-item>

                  <el-form-item label="原始值大小">
                    <div class="d-flex">
                      <el-input
                        @input="saveToLocalStorageData({tableDataKey: 'mod_data'})"
                        v-model="resources_class.size"
                        class="w-100px"
                      ></el-input>
                      <span class="ms-1">MB</span>
                    </div>
                  </el-form-item>
                </el-form>
                <el-table
                  size="mini"
                  border
                  v-loading="modLoading"
                  :data="mod_data"
                  class="type-table"
                  row-key="rowKey"
                  @sort-change="mode_sort_change"
                  @cell-click="onCellClick"
                  :header-cell-style="{
                    background: '#5D99D5',
                    color: '#fff'
                  }">
                  <el-table-column label="模块">
                    <template #default="scope">
                      <span>{{ scope.row["模块"] }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="当前版本">
                    <template #default="scope">
                      <div
                        :style="
                          getColor_config_size(
                            scope.row.size,
                            resources_class.size
                          )
                        "
                        class="pointer"
                        >{{ scope.row["内存"] }}</div
                      >
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="对比版本">
                    <template #default="scope">
                      <span>{{ scope.row["对比版本"] }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="change"
                    sortable="custom"
                    align="center"
                    label="差值"
                  >
                    <template #default="scope">
                      <span
                        :style="
                          getColor_config_size(
                            scope.row.change,
                            resources_class.change_size
                          )
                        "
                        >{{ scope.row["变化"] }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <h6
                  style="
                    display: flex;
                    align-items: center;
                    margin: 8px 0 8px 0;
                  "
                >
                  <span class="subTitle">◆</span>
                  数据占比
                </h6>
                <div
                  style="display: flex"
                  v-loading="modLoading"
                  class="spacName"
                >
                  <div id="mod" style="width: 41.62%; height: 360px"></div>
                  <div style="width: 58.38%">
                    <el-table
                      border
                      size="mini"
                      :header-cell-style="{
                        background: '#f5f7fa'
                      }"
                      @sort-change="mode_sort_change"
                      :cell-style="cellStyle"
                      :data="mod_table"
                    >
                      <el-table-column
                        label="模块"
                        prop="模块"
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="size"
                        label="内存"
                        sortable="custom"
                      >
                        <template #default="scope">
                          {{ scope.row["内存"] }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="rate"
                        width="80"
                        label="占比"
                        sortable="custom"
                      >
                        <template #default="scope">
                          {{ scope.row["占比"] }}
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop="change"
                        width="80"
                        label="变化"
                        sortable="custom"
                      >
                        <template #default="scope">
                          {{ scope.row["变化"] }}
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-footer style="padding: 5px 0px; text-align: right">
                      <el-form :inline="true" size="mini">
                        <el-form-item style="margin-bottom: 0">
                          <el-pagination
                            v-model:currentPage="currentPage_mod"
                            :page-size="size_mod"
                            layout="total, prev, pager, next, jumper"
                            :total="(mod_data || []).length"
                            @current-change="mode_current_change"
                          ></el-pagination>
                        </el-form-item>
                      </el-form>
                    </el-footer>
                  </div>
                </div>
                <el-card v-loading="mod_loading">
                  <div style="height: 500px" id="mod_trend"></div>
                </el-card>
              </div>
              <div>
                <h5 id="memory_scroll" class="TitleStyle">
                  <span></span>模块详情
                </h5>
                <el-form :inline="true" size="mini">
                  <el-form-item label="模块">
                    <el-select
                      v-model="source"
                      @change="source_current_change(true)"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in source_list"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>

                <el-form :inline="true" size="mini">
                  <el-form-item label="变化值大小">
                    <div class="d-flex">
                      <el-input
                        @input="saveToLocalStorageData({tableDataKey: 'moduleTableData'})"
                        v-model="moduleDetail.change_size"
                        class="w-100px"
                      ></el-input>
                      <span class="ms-1">MB</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="变化值数量">
                    <el-input
                      @input="saveToLocalStorageData({tableDataKey: 'moduleTableData'})"
                      v-model="moduleDetail.change_count"
                      class="w-100px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="原始值大小">
                    <div class="d-flex">
                      <el-input
                        @input="saveToLocalStorageData({tableDataKey: 'moduleTableData'})"
                        v-model="moduleDetail.size"
                        class="w-100px"
                      ></el-input>
                      <span class="ms-1">MB</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="原始值数量">
                    <el-input
                      @input="saveToLocalStorageData({tableDataKey: 'moduleTableData'})"
                      v-model="moduleDetail.count"
                      class="w-100px"
                    ></el-input>
                  </el-form-item>
                </el-form>

                <el-table 
                  border
                  size="mini"
                  :header-cell-style="{
                    background: '#5D99D5',
                    color: '#fff'
                  }"
                  row-key="rowKey"
                  :key="sorceTableKey"
                  ref="sorceTableRef"
                  :data="moduleTableData"
                  @sort-change="onModuleSortChange"
                  id="module-detail-table"
                  fit>
                  <el-table-column
                    label="资源名称"
                    prop="name"
                    fixed="left"
                    min-width="350"
                  ></el-table-column>
                  <el-table-column
                    label="当前版本"
                    min-width="620">
                    <template #default="scope">
                      <div style="display: flex">
                        <span
                          class="memory_margin_row"
                          :style="sameSizeCount(scope.row.change, 'size')"
                          >大小:<span
                            :style="
                              getColor_config_size2(scope.row.size, moduleDetail.size)
                            "
                            >{{ scope.row["内存"] }}</span
                          ></span
                        >
                        <span
                          class="memory_margin_row_count"
                          :style="sameSizeCount(scope.row.diff_count, 'count')"
                          >数量:<span
                            :style="
                              getColor_config_count(
                                scope.row.count,
                                moduleDetail.count
                              )
                            "
                            >{{ scope.row.count }}</span
                          ></span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.Width, scope.row.old.Width)"
                          >Width:{{ scope.row.Width }}</span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.Height, scope.row.old.Height)"
                          >Height:{{ scope.row.Height }}</span
                        >
                        <span
                          class="memory_margin_Format"
                          :style="same(scope.row.Format, scope.row.old.Format)"
                          >Format:{{ scope.row.Format }}</span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.MipMap, scope.row.old.MipMap)"
                          >MipMap:{{ scope.row.MipMap }}</span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.ISRead, scope.row.old.ISRead)"
                          >ISRead:{{ scope.row.ISRead }}</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="对比版本"
                    min-width="520">
                    <template #default="scope">
                      <div style="display: flex">
                        <span
                          class="memory_margin_row"
                          :style="sameSizeCount(scope.row.change, 'size')"
                          >大小:<span :style="getColor_1(scope.row.change)">{{
                            scope.row.old["内存"]
                          }}</span></span
                        >
                        <span
                          class="memory_margin_row_count"
                          :style="sameSizeCount(scope.row.diff_count, 'count')"
                          >数量:<span
                            :style="getCount_10(scope.row.diff_count)"
                            >{{ scope.row.old.count }}</span
                          ></span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.Width, scope.row.old.Width)"
                          >Width:{{ scope.row.old.Width }}</span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.Height, scope.row.old.Height)"
                          >Height:{{ scope.row.old.Height }}</span
                        >
                        <span
                          class="memory_margin_Format"
                          :style="same(scope.row.Format, scope.row.old.Format)"
                          >Format:{{ scope.row.old.Format }}</span
                        >
                        <span
                          class="memory_margin_row"
                          :style="same(scope.row.Format, scope.row.old.Format)"
                          >MipMap:{{ scope.row.old.MipMap }}</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="变化值"
                    min-width="150"
                    prop="change" 
                    sortable="custom">
                    <template #default="scope">
                      <div style="display: flex">
                        <div class="margin_div">
                          <div>
                            大小:

                            <span
                              :style="
                                getColor_config_size(
                                  scope.row.change,
                                  moduleDetail.change_size
                                )
                              "
                              >{{
                                formattedChange(scope.row.change, true)
                              }}</span
                            >
                          </div>
                        </div>
                        <div class="margin_div">
                          <div>
                            数量:

                            <span
                              :style="
                                getColor_config_count(
                                  scope.row.diff_count,
                                  moduleDetail.change_count
                                )
                              "
                              >{{
                                formattedChange(scope.row.diff_count, false)
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>

                <el-footer style="padding: 5px 0px; text-align: right">
                  <el-form :inline="true" size="mini">
                    <el-form-item label="每页">
                      <el-input
                        v-model="source_size"
                        @change="source_current_change(true)"
                        style="width: 55px; height: 28px"
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="条记录"></el-form-item>
                    <el-form-item style="margin-bottom: 0">
                      <el-pagination
                        v-model:currentPage="source_page"
                        :page-size="source_size"
                        layout="total, prev, pager, next, jumper"
                        :total="moduleTableTotal"
                        @current-change="source_current_change(false)"
                      ></el-pagination>
                    </el-form-item>
                  </el-form>
                </el-footer>
              </div>
            </div>
          </div>

          <!-- <div class="footer">
            <img src="../../assets/performance/footer.png" alt />
          </div> -->
          <div class="dialogForm">
            <el-dialog
              v-model="dialog_config"
              width="30%"
              @close="dialog_config = false"
            >
              <template #title>
                <div class="dialogTitle">
                  <span>阈值配置</span>
                  <el-divider></el-divider>
                </div>
              </template>
              <el-form :model="dialogConfigData" size="small">
                <el-form-item label="本身值大小">
                  <el-input v-model="dialogConfigData.size"></el-input>
                </el-form-item>
                <el-form-item label="本身值数量">
                  <el-input v-model="dialogConfigData.count"></el-input>
                </el-form-item>
                <el-form-item label="变化值大小">
                  <el-input v-model="dialogConfigData.change_size"></el-input>
                </el-form-item>

                <el-form-item label="变化值数量">
                  <el-input v-model="dialogConfigData.change_count"></el-input>
                </el-form-item>
              </el-form>

              <template #footer>
                <span class="dialog-footer">
                  <el-button
                    size="small"
                    type="primary"
                    @click="openConfig('close')"
                    >确 定</el-button
                  >
                </span>
              </template>
            </el-dialog>
          </div>
          <div class="dialogForm">
            <el-dialog
              v-model="dialogVisible"
              width="50%"
              @close="dialogVisible = false"
            >
              <template #title>
                <div class="dialogTitle">
                  <span>上传原始文件</span>
                  <el-divider></el-divider>
                </div>
              </template>
              <el-form
                :inline="true"
                :model="dialogForm"
                size="small"
                label-position="top"
              >
                <el-form-item label="任务ID">
                  <el-input v-model="dialogForm.task_record_id"></el-input>
                </el-form-item>
                <el-form-item label="设备">
                  <el-select
                    v-model="dialogForm.device_id"
                    placeholder="请选择设备"
                    filterable
                  >
                    <el-option
                      v-for="(item, index) in DeviceSpecs"
                      :key="index"
                      :label="
                        item.model.name +
                        ' (' +
                        item.model.model +
                        ') - ' +
                        item.UUID
                      "
                      :value="item.id"
                      :title="
                        item.model.name +
                        ' (' +
                        item.model.model +
                        ') - ' +
                        item.UUID
                      "
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="场景">
                  <div class="d-flex align-items-center">
                    <el-select
                      v-model="dialogForm.script_id"
                      placeholder="请选择场景"
                      filterable
                      clearable>
                      <el-option
                        v-for="(item, index) in scene_list_up"
                        :key="index"
                        :label="item.label"
                        :value="item.name"
                      ></el-option>
                    </el-select>

                    <span class="el-icon-plus fs-5 ms-1 cursor-pointer" @click="showAddSceneDialog"></span>
                  </div>
                </el-form-item>

                <el-form-item class="memory_version_input" label="版本">
                  <el-row style="display:flex;flex-wrap: nowrap"
                    >1.<el-input
                      v-model="dialogForm.game_version_first"
                    ></el-input
                    >0.<el-input
                      v-model="dialogForm.game_version_second"
                    ></el-input
                  ></el-row>
                </el-form-item>
              </el-form>
              <el-form
                :inline="true"
                :model="dialogForm"
                size="small"
                label-position="top"
              >
                <el-form-item class="memory_tips_input" label="备注">
                  <el-input v-model="dialogForm.tips"></el-input>
                </el-form-item>
              </el-form>
              <el-form :model="dialogForm" size="small" label-position="top">
                <el-form-item label="上传文件">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="http://127.0.0.1:8081/api/v1/memory/speedm_memory_upload/"
                    multiple
                    :limit="1"
                    :before-upload="beforeUpload"
                    :ref="'upload'"
                    :http-request="UploadFile"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      将文件拖到此处，或
                      <em>点击上传</em>
                    </div>
                    <template #tip>
                      <div class="el-upload__tip">只能上传log文件</div>
                    </template>
                  </el-upload>
                </el-form-item>
              </el-form>
              <template #footer>
                <span class="dialog-footer">
                  <el-button size="small" @click="submitUpload('no')"
                    >重 置</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="submitUpload('ok')"
                    >确 定</el-button
                  >
                </span>
              </template>
            </el-dialog>
          </div>
          <div class="dialogForm">
            <el-dialog
              v-model="dialogVisible_result"
              width="50%"
              @close="dialogVisible_result = false"
            >
              <template #title>
                <div class="dialogTitle">
                  <span>上传结果文件</span>
                  <el-divider></el-divider>
                </div>
              </template>
              <el-form
                :inline="true"
                :model="dialogForm_result"
                size="small"
                label-position="top"
              >
                <el-form-item label="任务ID">
                  <el-input
                    v-model="dialogForm_result.task_record_id"
                  ></el-input>
                </el-form-item>
                <el-form-item label="设备">
                  <el-input v-model="dialogForm_result.device_id"> </el-input>
                </el-form-item>

                <el-form-item label="场景">
                  <el-input v-model="dialogForm_result.scene_name"></el-input>
                </el-form-item>
                <el-form-item label="版本">
                  <el-input v-model="dialogForm_result.version"></el-input>
                </el-form-item>
              </el-form>
              <el-form
                :inline="true"
                :model="dialogForm"
                size="small"
                label-position="top"
              >
                <el-form-item class="memory_tips_input" label="备注">
                  <el-input v-model="dialogForm_result.tips_up"></el-input>
                </el-form-item>
              </el-form>
              <el-form :model="dialogForm" size="small" label-position="top">
                <el-form-item label="上传文件">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="http://127.0.0.1:8081/api/v1/memory/speedm_memory_upload/"
                    multiple
                    :limit="1"
                    :before-upload="beforeUpload_result"
                    :ref="'upload'"
                    :http-request="UploadFile_result"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      将文件拖到此处，或
                      <em>点击上传</em>
                    </div>
                    <template #tip>
                      <div class="el-upload__tip">只能上传zip文件</div>
                    </template>
                  </el-upload>
                </el-form-item>
              </el-form>
              <template #footer>
                <span class="dialog-footer">
                  <el-button size="small" @click="submitUpload_result('no')"
                    >重 置</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="submitUpload_result('ok')"
                    >确 定</el-button
                  >
                </span>
              </template>
            </el-dialog>
          </div>
        </div>
      </div>
    </el-container>
    <div class="nav-container">
      <div class="nav-button" @click="toggleNav">
        <div style="margin-bottom: 10px">
          <span class="iconfont icon-daohang"></span>
        </div>
        <div class="vertical-text">导航</div>
      </div>

      <div :class="{ 'nav-list': true, active: isNavOpen }" id="nav-list">
        <!-- 导航列表内容 -->
        <div class="nav-list-box">
          <div @click="scrollBtn('all_scroll')">资源汇总</div>
          <div @click="scrollBtn('detail_scroll')">资源详情</div>
          <div @click="scrollBtn('class_scroll')">资源分类</div>
          <div @click="scrollBtn('memory_scroll')">模块详情</div>
        </div>
      </div>
    </div>

    <el-dialog
      v-model="dialogRemark"
      title="输入备注"
      width="500">
      <el-input v-model="linkRemark" />
      <template #footer>
        <div class="dialog-footer">
          <el-button size="mini" @click="dialogRemark = false">取消</el-button>
          <el-button size="mini" type="primary" @click="onEnsureRemark">确认</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="添加场景选项" v-model="visibleDialogAddScene" width="500px">
      <el-form ref="form" :model="sceneForm" label-width="auto">
        <el-form-item label="场景英文">
          <el-input v-model="sceneForm.name" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="场景中文">
          <el-input v-model="sceneForm.chinese" size="mini"></el-input>
        </el-form-item>
      </el-form>

      <template class="dialog-footer" #footer>
        <el-button size="mini" @click="visibleDialogAddScene = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="addScene">确 定</el-button>
      </template>
    </el-dialog>

    
    <el-dialog title="上传原始文件" v-model="dialogFileVisible" width="800px" :close-on-click-modal="false">
      <el-form ref="originForm" :model="originFormData" size="mini" label-width="80px" :rules="originRules" hide-required-asterisk>
        <div class="d-flex">
          <el-upload
            class="upload-demo"
            multiple
            action=""
            accept=".log"
            :limit="100"
            :file-list="originFormData.fileList"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="handleChange">
            <el-button size="mini" type="primary">点击上传</el-button>
          </el-upload>

          <el-form-item label="测试ID" prop="testId" class="mb-0 ms-5">
            <el-input v-model="originFormData.testId" size="mini" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
      
        <div class="mt-4">
          <div v-for="file of originFormData.fileList" :key="file.uid" class="d-flex mt-2">
            <span class="w-50">文件名：{{file.name}}</span>
            <span class="d-flex align-items-center flex-grow-1">
              <span class="flex-shrink-0">备注：</span>
              <el-input v-model="file.tips_up" size="mini" class="" />
            </span>
          </div>
        </div>
      </el-form>

      <template class="dialog-footer" #footer>
        <el-button size="mini" @click="dialogFileVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitFiles">确 定</el-button>
      </template>
    </el-dialog>

    <add-remark api="memory/speedm_memory_remark/" />
  </el-container>
</template>

<script>
//html与gametool有一些差别，js与css仅下面两行不同
import { ElMessage } from "element-plus";
//import { Message as ElMessage } from "element-ui";

import { getLocalProject, gtAxios, grAxios } from "@/utils"; //类型
import * as echarts from "echarts";
// import "@/assets/iconfont/font_3410179_7jzi7zxz4zw/iconfont.css"; //引入仓库
import fileSaver from "file-saver";
import * as XLSX from "xlsx";
import AddRemark from '@/views/speedm/common/add-remark/index.vue'

const useDetailData = { //详细数据表格
  data() {
    return {
      summaryList: [],
      detailType: '',
    }
  },

  computed: {
    // summaryList() {
    //   let list = this.fileData.top_list.map(item => {
    //     item.rowKey = Math.random()
    //     return item
    //   });
    //   list?.sort((a, b) => b.change - a.change);
    //   return list;
    // },

    detailTableData() {
      return (this.filterSummaryList || []).slice(
        (this.file_page - 1) * this.file_record,
        this.file_page * this.file_record
      )
    },

    filterSummaryList() {
      return this.summaryList.filter(item => item.name.includes(this.detailType))
    },
  },

  methods: {
    onDetailTypeInput() {
      this.saveToLocalStorageData({tableDataKey: 'summaryList'})
    },

    onDetailSortChange({column, prop, order}) {
      if (prop !== 'change') return

      if (order == 'ascending') {
        this.summaryList.sort((a, b) => a.change - b.change)
      } else if (order == 'descending') {
        this.summaryList.sort((a, b) => b.change - a.change)
      } else {
        this.summaryList = JSON.parse(JSON.stringify(this.fileData.top_list))
      }
      this.summaryList.forEach(item => item.rowKey = Math.random())
    },

    async getSpeedmMemorySummary() {
      const { data } = await gtAxios({
        url: "/memory/res_summary/",
        params: {
          project: this.localProject,
          id_test: this.id_test,
          old_test: this.old_test,
          filename: this.fileName
        }
      });

      this.fileData = data
      this.summaryList = JSON.parse(JSON.stringify(data.top_list))
    },
  }
}

/* 模块详情 */
const useModuleDetail = {
  data() {
    return {
      source_table: [],
      moduleTableData: [],
      moduleTableTotal: 0,
      sort_param: "size",
      sort_reverse: 1,
    }
  },

  computed: {
    // sourceTableData() {
    //   return (this.source_table || {}).results
    // },
  },

  watch: {
    // sourceTableData() {
    //   this.sorceTableKey = Math.random()
    //   //this.$refs.sorceTableRef.doLayout()
    // }
  },

  methods: {
    async getSpeedmSourceFileList() {
      const { data } = await gtAxios({
        //url: "/memory/mod_source_list/",
        url: '/memory/mod_source_compare/',
        params: {
          project: this.localProject,
          filename: this.source,
          id_test: this.id_test,
          old_test: this.old_test,
          page: this.source_page,
          page_size: this.source_size,
          param: this.sort_param,
          reverse: this.sort_reverse,
          // size: this.source_size,
        }
      });

      this.moduleTableData = data.results.map(item => {
        item.change = item.change * 1024
        item.rowKey = Math.random()
        return item
      })
      this.moduleTableTotal = data.count
    },

    async sort_change_memory(column) {
      this.source_loading = true;
      this.sort_param = column.prop ? column.prop : "";
      this.sort_reverse = column.order
        ? column?.order == "ascending"
          ? 0
          : 1
        : "";
      await this.getSpeedmSourceFileList();
      this.source_loading = false;
    },

    async source_current_change(type) {
      this.saveToLocalStorage()
      this.source_loading = true
      this.source_page = type ? 1 : this.source_page
      this.sort_param = type ? "size" : this.sort_param
      this.sort_reverse = type ? 1 : this.sort_reverse

      await this.getSpeedmSourceFileList()
      this.source_loading = false
    },

    onModuleSortChange({column, prop, order}) {
      if (order == 'ascending') {
        this.sort_param = prop
        this.sort_reverse = 0
      } else if (order == 'descending') {
        this.sort_param = prop
        this.sort_reverse = 1
      } else {
        this.sort_param = 'size'
        this.sort_reverse = 1
      }
      this.getSpeedmSourceFileList()
    }
  }
}

/** 改变url参数相关逻辑 **/
const useChangeUrl = {
  methods: {
    changeQuery() {
      this.$router.push({
        query: {
          ...this.$route.query,
          date: this.date,
          record_id: this.record_id,
          //version: encodeURIComponent(this.version),
          version: this.version,
          device_id: this.device_id,
          //scene_name: encodeURIComponent(this.scene_name),
          scene_name: this.scene_name,
          old_date: this.old_date,
          record_id_old: this.record_id_old,
          //old_version: encodeURIComponent(this.old_version),
          old_version: this.old_version,
          device_id_old: this.device_id_old,
          //scene_name_old: encodeURIComponent(this.scene_name_old),
          scene_name_old: this.scene_name_old,
        }
      });
    },

    async onFormItemChange(newVal, field, arr, isOld) {
      if (isOld) {
        await this.options_data_old_api(arr);
      } else {
        await this.options_data_api(arr);
      }

      this.saveToLocalStorage()
    },

    changeForm(isInit) {
      if (!isInit) return

      const {
        date,
        record_id,
        version,
        device_id,
        scene_name,
        old_date,
        record_id_old,
        old_version,
        device_id_old,
        scene_name_old
      } = this.$route.query;

      if (date) this.date = date;
      if (record_id) this.record_id = Number(record_id);
      //if (version) this.version = decodeURIComponent(version);
      if (version) this.version = version
      if (device_id) this.device_id = Number(device_id);
      //if (scene_name) this.scene_name = decodeURIComponent(scene_name);
      if (scene_name) this.scene_name = scene_name
      if (old_date) this.old_date = old_date;
      if (record_id_old) this.record_id_old = Number(record_id_old);
      //if (old_version) this.old_version = decodeURIComponent(old_version);
      if (old_version) this.old_version = old_version
      if (device_id_old) this.device_id_old = Number(device_id_old);
      //if (scene_name_old) this.scene_name_old = decodeURIComponent(scene_name_old);
      if (scene_name_old) this.scene_name_old = scene_name_old
    },
  }
}

const useStorage = {
  methods: {
    loadFromLocalStorage() {
      const formData = localStorage.getItem("formDataOverview");
      if (formData) {
        const data = JSON.parse(formData);
        this.formDataOverview.date = data.date;
        this.formDataOverview.record_id = data.record_id;
        this.formDataOverview.version = data.version;
        this.formDataOverview.device_id = data.device_id;
        this.formDataOverview.scene_name = data.scene_name;
        this.formDataOverview.fileName = data.fileName;
        this.formDataOverview.moduleName = data.moduleName;
        this.formDataOverview.old_date = data.old_date;
        this.formDataOverview.record_list_old = data.record_list_old;
        this.formDataOverview.old_version = data.old_version;
        this.formDataOverview.device_list_old = data.device_list_old;
        this.formDataOverview.scene_list_old = data.scene_list_old;
      }
    },
    loadFromLocalStorageData() {
      const formData = localStorage.getItem("thresholdValue");
      if (formData) {
        const data = JSON.parse(formData);
        this.resources_class = data.resources_class;
        (this.change_size = data.change_size),
        (this.resources = data.resources);
        this.detail = data.detail;
        this.moduleDetail = data.moduleDetail || {
          change_size: 1,
          change_count: 10,
          size: 1,
          count: 10
        }
      }
    },
    saveToLocalStorage() {
      localStorage.setItem(
        "formDataOverview",
        JSON.stringify({
          date: this.date,
          record_id: this.record_id,
          version: this.version,
          device_id: this.device_id,
          //scene_name: encodeURIComponent(this.scene_name),
          scene_name: this.scene_name,
          //fileName: encodeURIComponent(this.fileName),
          fileName: this.fileName,
          //moduleName: encodeURIComponent(this.source),
          moduleName: this.source,
          old_date: this.old_date,
          record_list_old: this.record_id_old,
          old_version: this.old_version,
          device_list_old: this.device_id_old,
          //scene_list_old: encodeURIComponent(this.scene_name_old)
          scene_list_old: this.scene_name_old,
        })
      );
    },
    saveToLocalStorageData({tableDataKey, dataField} = {}) {
      localStorage.setItem(
        "thresholdValue",
        JSON.stringify({
          resources_class: {
            size: this.resources_class.size,
            change_size: this.resources_class.change_size
          },
          resources: {
            change_size: this.resources.change_size,
            change_count: this.resources.change_count,
            size: this.resources.size,
            count: this.resources.count
          },
          detail: {
            change_size: this.detail.change_size,
            change_count: this.detail.change_count,
            size: this.detail.size,
            count: this.detail.count
          },
          moduleDetail: this.moduleDetail,
          change_size: this.change_size
        })
      );

      if (tableDataKey && dataField) {
        this.sorceTableKey = Math.random()

        // const data = this?.[tableDataKey]?.[dataField]
        // //console.log('saveToLocalStorageData', tableDataKey, dataField, data)
        // data?.forEach(item => item.rowKey = Math.random())
      } else if (tableDataKey) {
        this[tableDataKey].forEach(item => item.rowKey = Math.random())
      }
    },
  }
}

/* 保存链接 */
const useSaveLink = {
  data() {
    return {
      dialogRemark: false,
      linkRemark: '',
      links: [],
      curLinkPage: 1,
      LinkpageSize: 2,
      linkTotal: 0,
    }
  },

  methods: {
    saveCurLink() {
      this.linkRemark = ''
      this.dialogRemark = true
    },

    async onEnsureRemark() {
      const res = await grAxios({
        url: 'memory/speedm_memory_link/',
        method: 'post',
        data: {
          project: this.localProject,
          id_test: this.id_test,
          link: location.href,
          remark: this.linkRemark,
        }
      })

      if (res.status == 200) {
        ElMessage.success('保存成功')
        this.dialogRemark = false
      }
    },
  }
}

const useAddSceneOptionDialog = { //添加场景弹窗
  data() {
    return {
      visibleDialogAddScene: false,
      sceneForm: {
        name: '',
        chinese: '',
      },
      scene_list_up: [],
    }
  },

  created() {
    this.getSceneOptions()
  },

  methods: {
    showAddSceneDialog() {
      this.visibleDialogAddScene = true
    },

    async getSceneOptions() {
      const {data} = await grAxios({
        url: 'memory/scene_list/',
        params: {
          project: this.localProject,
        }
      })
      this.scene_list_up = data.map((item, index) => {
        item.label = `${index + 1}-${item.chinese}`
        return item
      })
    },

    async addScene() {
      await grAxios({
        method: 'post',
        url: 'memory/scene_list/',
        data: {
          project: this.localProject,
          ...this.sceneForm,
        }
      })
      ElMessage.success('添加成功')
      this.visibleDialogAddScene = false
      this.sceneForm = {
        name: '',
        chinese: '',
      }
      this.getSceneOptions()
    }
  }
}

const useAddDeviceOptionDialog = { //添加设备弹窗
  data() {
    return {
      visibleDialogAddDevice: false,
      deviceForm: {
        name: '',
        model: '',
        ram: '',
      },
    }
  },

  methods: {
    showAddDeviceDialog() {
      this.visibleDialogAddDevice = true
    },

    async getSceneOptions() {
      const {data} = await grAxios({
        url: 'memory/scene_list/',
        params: {
          project: this.localProject,
        }
      })
      this.scene_list_up = data.map((item, index) => {
        item.label = `${index + 1}-${item.chinese}`
        return item
      })
    },

    async addDevice() {
      await grAxios({
        method: 'post',
        url: 'device/device_register/',
        data: this.deviceForm
      })
      ElMessage.success('添加成功')
      this.visibleDialogAddDevice = false
      this.deviceForm = {
        name: '',
        model: '',
        ram: '',
      }
      this.getDeviceSpecs()
    }
  }
}

const useUploadOriginFile = { //上传原始文件弹窗
  data() {
    return {
      dialogFileVisible: false,
      originFormData: {
        fileList: []
      },
      originRules: {
        testId: [
          {required: true, message: '必填'}
        ]
      },
    }
  },

  methods: {
    async submitFiles() {
      this.$refs.originForm.validate(async (valid) => {
        if (valid) {
          for (let file of this.originFormData.fileList) {
            await this.submitFile(file)
          }

          ElMessage.success('上传成功')
          this.dialogFileVisible = false
        }
      })
    },

    async submitFile(file) {
      const data = new FormData()
      data.append('file', file.raw)
      data.append('task_record_id', this.originFormData.testId)
      data.append('tips_up', file.tips_up)
      data.append('project', 0)

      await grAxios({
        method: "post",
        //baseURL: 'https://memdump.pika.work',
        //baseURL: 'https://resmem.pika.work',
        //urlPre: '',
        url: "memory/speedm_memory_log/",
        data,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    },

    uploadOriginFile() {
      this.dialogFileVisible = true
      this.originFormData = {
        fileList: []
      }
      this.$refs.originForm?.clearValidate()
    },

    handleChange(file, fileList) {
      this.originFormData.fileList = fileList
    }
  }
}

export default {
  mixins: [useStorage, useModuleDetail, useChangeUrl, useSaveLink, useAddSceneOptionDialog, useDetailData, useAddDeviceOptionDialog, useUploadOriginFile],

  data() {
    return {
      moduleDetail: {
        change_size: 1,
        change_count: 10,
        size: 1,
        count: 10
      },
      memoryList: [],
      resData: { top_list: [], list: {} },
      fileData: { top_list: [], list: {} },
      mod_data: [],

      //声明属性
      resources: {
        change_size: 10,
        change_count: 50,
        size: 50,
        count: 200
      },
      resources_class: {
        size: 80,
        change_size: 20
      },
      
      
      get_config_data: {},
      source_list: [],
      
      source_page: 1,
      source_size: 20,
      source: "",
      
      memoryFileList: [],
      form_result_data: new FormData(),
      formData: new FormData(),
      localProject: Number(getLocalProject()), //得到本地的项目
      id_test: "",
      old_test: "",
      fileName: "",

      sceneList: [],
      sceneOldList: [],

      mem_list: [],

      mem_loading: false,
      current_page: 1,
      record: 20,
      file_page: 1,
      file_record: 20,
      mod_size: 20,
      mod_page: 1,
      res_page: 1,
      res_size: 20,
      res_page_v1: 1,
      res_size_v1: 20,
      record_list: [],
      record_list_old: [],
      scene: "",
      record_id: "",
      record_id_old: "",
      device_list: [],
      device_list_old: [],
      device_id: "",
      device_id_old: "",
      scene_list: [],
      scene_list_old: [],
      scene_name: "",
      scene_name_old: "",
      date: "",
      old_date: "",
      date_list: [],
      source_loading: false,
      change_size: 20,
      modListData: {},
      mod_summary_table: [],
      res_summary_table: [],
      summary_table_loading: false,
      size_value: 0,
      count_value: 0,
      valueTime: [],
      modLoading: false,
      dialogForm: {
        scene_id: "",
        script_id: "",
        tips: "",
        UUID: "",
        device_id: "",
        task_record_id: "",
        game_version: "",
        game_version_first: "",
        game_version_second: ""
      },
      dialogForm_result: {
        scene_name: "",
        version: "",
        task_record_id: "",
        device_id: "",
        tips_up: ""
      },
      dialogConfigData: {
        change_size: 1,
        change_count: 50,
        count: 200,
        size: 10
      },
      dialogConfigData_change: {
        change_size: 1,
        change_count: 50,
        count: 200,
        size: 10
      },
      dialogVisible: false,
      dialogVisible_result: false,
      dialog_config: false,

      currentPage: 1,
      size: 10,
      currentPage_mod: 1,
      size_mod: 10,
      file_size: 10,
      file_currentPage: 1,

      version: "",
      detail_size: 1,
      detail_count: 10,
      detail: {
        change_size: 1,
        change_count: 50,
        size: 10,
        count: 50
      },
      formDataOverview: {
        date: "",
        record_id: "",
        version: "",
        device_id: "",
        scene_name: "",
        fileName: "",
        moduleName: "",
        old_date: "",
        record_list_old: "",
        old_version: "",
        device_list_old: "",
        scene_list_old: ""
      },
      old_version: "",
      colors: [
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#935bab",
        "#d872bc",
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#935bab",
        "#d872bc"
      ],
      resPieData: [],
      fulePieData: [],
      checkCol: [],
      checkDetailList: [],
      checkTable: [],
      resSummaryList: {},
      tableAddShow: false,
      typeList: [
        { name: "增量", value: "0" },
        { name: "全量", value: "1" }
      ],
      res_table_list: [],
      file_table_list: [],
      res_detail_table: [],
      file_detail_table: [],
      mod_table: [],
      type: "",
      mod_num: 0,
      modPieData: [],
      memoryTrendData: {
        date_list: [],
        module_list: [],
        series: []
      },
      resTrendData: {
        date_list: [],
        module_list: [],
        series: []
      },
      sort_param_v1: "size_diff",
      sort_reverse_v1: 1,
      memory_detail_list: [],
      memory_loading: false,
      res_loading: false,
      fixed: false,
      DeviceSpecs: [],
      momory_loading_v1: false,
      mod_loading: false,
      modTrendData: {},
      isNavOpen: false,
      summary_res_table_loading: false,
      resLoading: false,
      fileLoading: false,
      speedmMemoryData: {},
      sorceTableKey: null,
      
    };
  },

  components: {AddRemark},

  async mounted() {
    this.getDeviceSpecs();
    //this.getSimpleScripts();

    this.resLoading = true;
    this.summary_res_table_loading = true;
    this.momory_loading_v1 = true;
    this.source_loading = true;
    this.summary_table_loading = true;
    this.res_loading = true;
    this.fileLoading = true;
    this.mem_loading = true;
    this.memory_loading = true;
    this.modLoading = true;
    this.mod_loading = true;
    this.size_value = 1;
    this.count_value = 10;
    window.addEventListener("scroll", this.fixedActiveBtn);
    if (this.$route.query.scroll) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$route.query.scroll == "memory") {
            this.scrollBtn("detail_scroll");
          } else if (this.$route.query.scroll == "module") {
            this.scrollBtn("memory_scroll");
          }
        }, 1000); // 在 $nextTick 内使用 setTimeout 来确保在 DOM 更新后执行
      });
    }
    this.loadFromLocalStorageData();
    await this.loadFromLocalStorage();

    //  const now = new Date();
    //   const oneWeekLater = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000); // 添加一周的时间（以毫秒为单位）
    //   this.valueTime=[now, oneWeekLater]
    const date_list = await this.getSpeedmMemoryDates();
    this.date_list = date_list;
    if (date_list.length > 0) {
      this.date = this.formDataOverview.date
        ? this.formDataOverview.date
        : date_list[0];
    }
    if (!this.formDataOverview.old_date) {
      this.get_old_version();
    } else {
      this.old_date = this.formDataOverview.old_date;
    }
    this.changeForm(true);

    await this.options_data_api(
      ["test_id", "records", "device", "scene"],
      true,
      true
    );

    await this.options_data_old_api(
      ["test_id", "records", "device", "scene"],
      true,
      true
    );
    this.source_api();
    this.memory_detail_api();

    await this.getSpeedmFilenameList();
    this.fileName = this.formDataOverview.fileName
      ? this.formDataOverview.fileName
      : this.memoryFileList[0];
    this.saveToLocalStorage();

    this.mem_api();

    this.mod_api();

    this.res_data_api();
    this.file_data_api();
    this.resTrend_api();
    this.memoryTrend_api();

    this.changeQuery()
  },

  methods: {
    toOverview() {
      this.$router.push({name: 'memory-resource-overview', query: this.$route.query})
    },

    async downFile({url, fileName} = {}) {
      const link = document.createElement('a')
      link.href = url
      link.download = url //设置下载的文件名
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    downSource() {
      this.downFile({url: this.speedmMemoryData.file_path})
    },

    getVersion(row, item) {
      return row.data.filter(v => v.version == item.version)[0][item.version]?.[row.name]
    },

    async onCellClick(row, col, cell) {
      if (col.label == '当前版本') {
        this.source = row['模块']
        await this.source_current_change(true)
        await this.$nextTick()
        document.getElementById('module-detail-table').scrollIntoView({
          behavior: 'instant'
        })
      }
    },

    async sleep(ms) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true);
        }, ms);
      });
    },

    async getSpeedmMemoryScenes(version, record_id, device_id, date) {
      const { data } = await grAxios({
        url: "/memory/speedm_memory_scenes/",
        params: {
          project: this.localProject,
          version,
          record_id,
          device_id,
          date
        }
      });

      return data;
    },

    async getSpeedmFilenameList() {
      const { data } = await gtAxios({
        url: `/memory/filename_list/`,
        params: {
          project: this.localProject,
          id_test: this.id_test
        }
      });

      this.memoryFileList = data;
    },

    async getSpeedmMemoryVersions(record_id, date) {
      const { data } = await grAxios({
        url: `/memory/speedm_memory_versions/`,
        params: {
          project: this.localProject,
          record_id,
          date
        }
      });
      return data;
    },

    async getSpeedmMemoryRecords(date) {
      const { data } = await grAxios({
        url: `/memory/speedm_memory_records/`,
        params: {
          project: this.localProject,
          date,
        }
      });

      return data;
    },

    async getSpeedmMemoryDevices(version, record_id, date) {
      const { data } = await grAxios({
        url: `/memory/speedm_memory_devices/`,
        params: {
          project: this.localProject,
          version,
          record_id,
          date
        }
      });
      return data;
    },

    async getResSummary() {
      const { data } = await gtAxios({
        url: `/memory/res_summary/`,
        params: {
          project: this.localProject,
          id_test: this.id_test,
          old_test: this.old_test,
          filename: "ResSummary"
        }
      });
      this.resData = data;
    },

    async getSpeedmMemoryResTrend(filename) {
      const { data } = await gtAxios({
        url: `/memory/speedm_memory_trend/`,
        params: {
          project: this.localProject,
          filename,
          scene_name: this.scene_name
        }
      });
      this.resTrendData = this.memoryTrendData = data;
    },

    async getSpeedmMemoryId(version, record_id, device_id, scene_name, date) {
      const { data } = await grAxios({
        url: "/memory/speedm_memory_id/",
        params: {
          project: this.localProject,
          version,
          record_id,
          device_id,
          scene_name,
          date
        }
      });
      return data;
    },

    async deleteMemory() {
      await gtAxios({
        method: "delete",
        url: "/memory/speedm_memory_upload/",
        params: {
          project: this.localProject,
          id_test: this.id_test
        }
      });
      await this.sleep(500);
    },

    async getSpeedModSummary() {
      const { data } = await gtAxios({
        url: "/memory/mod_summary/",
        params: {
          project: this.localProject,
          id_test: this.id_test,
          old_test: this.old_test
        }
      });

      this.mod_data = data.top_list.map(item => {
        item.rowKey = Math.random()
        return item
      });
    },

    async getSpeedmMemoryConfig() {
      const { data } = await gtAxios({
        url: "/memory/memory_config/",
        params: {
          project: this.localProject,
          key: "resource_memory"
        }
      });
      this.get_config_data = data;
    },

    async config_api() {
      await this.getSpeedmMemoryConfig();

      this.dialogConfigData.size = this.get_config_data.data.size;
      this.dialogConfigData.count = this.get_config_data.data.count;
      this.dialogConfigData.change_size = this.get_config_data.data.change_size;
      this.dialogConfigData.change_count = this.get_config_data.data.change_count;
      this.dialogConfigData_change.size = this.get_config_data.data.size;
      this.dialogConfigData_change.count = this.get_config_data.data.count;
      this.dialogConfigData_change.change_size = this.get_config_data.data.change_size;
      this.dialogConfigData_change.change_count = this.get_config_data.data.change_count;
    },

    async getSpeedmSourceList() {
      const { data } = await gtAxios({
        url: "/memory/mod_source_files/",
        params: {
          project: this.localProject,
          id_test: this.id_test
        }
      });
      this.source_list = data;
    },

    async source_api() {
      await this.getSpeedmSourceList();

      this.source =
        this.source_list.length > 0
          ? this.formDataOverview.moduleName
            ? this.formDataOverview.moduleName
            : "UI总量"
          : "";
      await this.getSpeedmSourceFileList();
      this.source_loading = false;
    },

    async getSpeedmMemoryDates() {
      const { data } = await grAxios({
        url: "/memory/speedm_memory_dates/",
        params: { project: this.localProject }
      });
      return data;
    },

    async uploadMemoryResult() {
      await gtAxios({
        method: "post",
        url: `/memory/speedm_memory_upload/`,
        data: this.form_result_data
      });
    },

    async submitUpload_result(btn) {
      if (btn === "ok") {
        this.dialogVisible_result = false;
        let b = this.$message({
          //Message 消息提示
          message: "上传中",
          showClose: true,
          duration: 0
        });

        this.form_result_data.append(
          "task_record_id",
          this.dialogForm_result.task_record_id
        );
        this.form_result_data.append(
          "scene_name",
          this.dialogForm_result.scene_name
        );

        this.form_result_data.append(
          "device_name",
          this.dialogForm_result.device_id
        );
        this.form_result_data.append("version", this.dialogForm_result.version);
        this.form_result_data.append("project", Number(this.localProject));
        this.form_result_data.append("tips_up", this.dialogForm_result.tips_up);
        this.dialogVisible = false;
        await this.uploadMemoryResult();

        b.close();
        ElMessage.success({
          message: "数据上传成功",
          showClose: true,
          type: "success"
        });
        // this.loading = false;

        this.resLoading = true;
        this.summary_res_table_loading = true;
        this.summary_table_loading = true;
        this.res_loading = true;
        this.fileLoading = true;
        this.mem_loading = true;
        this.memory_loading = true;
        this.modLoading = true;
        this.mod_loading = true;
        this.size_value = 1;
        this.count_value = 10;
        this.formData = new FormData();
        const date_list = await this.getSpeedmMemoryDates();
        this.date_list = date_list;
        if (date_list.length > 0) {
          this.date = date_list[0];
        }
        this.get_old_version();
        await this.options_data_api(["test_id", "records", "device", "scene"]);

        await this.options_data_old_api([
          "test_id",
          "records",
          "device",
          "scene"
        ]);
        await this.getSpeedmFilenameList();

        this.fileName = this.memoryFileList[0]
        this.mem_api();

        this.mod_api();
        this.res_data_api();
        this.file_data_api();
        this.resTrend_api();
        this.memoryTrend_api();
      }
      if (btn === "no") {
        this.dialogVisible_result = false;
        this.dialogForm_result = {
          scene_name: "",
          version: "",
          task_record_id: "",
          device_name: "",
          tips_up: ""
        };
        this.form_result_data = new FormData();
        this.$refs["upload"]?.clearFiles();
      }
      if (btn === "open") {
        this.dialogVisible_result = true;
        this.dialogForm_result = {
          scene_name: "",
          version: "",
          task_record_id: "",
          device_name: "",
          tips_up: ""
        };
        this.form_result_data = new FormData();
        this.$refs["upload"]?.clearFiles();
      }
    },

    async uploadMemory(data) {
      return await grAxios({
        method: "post",
        //baseURL: 'https://memdump.pika.work',
        //baseURL: 'https://resmem.pika.work',
        //urlPre: '',
        url: "memory/speedm_memory_log/",
        data,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },

    async submitUpload(btn) {
      if (btn === "ok") {
        // this.loading = true;
        let b = this.$message({
          //Message 消息提示
          message: "上传中",
          showClose: true,
          duration: 0
        });

        this.formData.append("task_record_id", this.dialogForm.task_record_id);
        this.formData.append("scenes", this.dialogForm.script_id);
        this.formData.append("device", this.dialogForm.device_id);

        this.formData.append(
          "version",
          "1." +
            this.dialogForm.game_version_first +
            ".0." +
            this.dialogForm.game_version_second
        );
        this.formData.append("tips_up", this.dialogForm.tips);
        this.formData.append("project", this.localProject);
        this.dialogVisible = false;
        const res = await this.uploadMemory(this.formData);
        if (!res) {
          ElMessage.error({
            message: "上传失败",
            showClose: true,
          })
          b.close()
          return
        }

        b.close();
        ElMessage.success({
          message: "数据上传成功",
          showClose: true,
          type: "success"
        });
        // this.loading = false;

        this.resLoading = true;
        this.summary_res_table_loading = true;
        this.summary_table_loading = true;
        this.res_loading = true;
        this.fileLoading = true;
        this.mem_loading = true;
        this.memory_loading = true;
        this.modLoading = true;
        this.mod_loading = true;
        this.size_value = 1;
        this.count_value = 10;
        this.formData = new FormData();
        const date_list = await this.getSpeedmMemoryDates();
        this.date_list = date_list;
        if (date_list.length > 0) {
          this.date = date_list[0];
        }
        this.get_old_version();
        await this.options_data_api(["test_id", "records", "device", "scene"]);

        await this.options_data_old_api([
          "test_id",
          "records",
          "device",
          "scene"
        ]);
        await this.getSpeedmFilenameList();
        this.fileName = this.memoryFileList[0]
        this.mem_api();

        this.mod_api();
        this.res_data_api();
        this.file_data_api();
        this.resTrend_api();
        this.memoryTrend_api();
      }

      if (btn === "no") {
        this.dialogForm = {
          scene_id: "",
          script_id: "",
          tips: "",
          UUID: "",
          device_id: "",
          task_record_id: "",
          game_version: "",
          game_version_first: "",
          game_version_second: ""
        };
        this.formData = new FormData();
        this.$refs["upload"].clearFiles();
      }
      if (btn === "open") {
        this.dialogVisible = true;
        this.dialogForm = {
          scene_id: "",
          script_id: "",
          task_record_id: this.generateRandomId().toString(),
          UUID: "",
          device_id: "",
          tips: "",
          game_version: "",
          game_version_first: "",
          game_version_second: ""
        };
        this.formData = new FormData();
        this.$refs["upload"]?.clearFiles();
      }
    },
    generateRandomId() {
      return Math.floor(10000 + Math.random() * 90000); // 10000 到 99999
    },
    async UploadFile(param) {
      this.formData.append("file", param.file);
    },
    async UploadFile_result(param) {
      this.form_result_data.append("file", param.file);
    },

    
    async deleteBtn() {
      this.resLoading = true;
      this.res_loading = true;
      this.fileLoading = true;
      this.mem_loading = true;
      this.summary_table_loading = true;
      this.memory_loading = true;
      this.modLoading = true;
      this.mod_loading = true;
      this.summary_res_table_loading = true;
      this.momory_loading_v1 = true;
      this.source_size = 20;
      this.source_page = 1;
      this.source_loading = true;
      await this.deleteMemory();

      const date_list = await this.getSpeedmMemoryDates();
      this.date_list = date_list;
      if (date_list.length > 0) {
        this.date = date_list[0];
      }
      this.get_old_version();
      await this.options_data_api(["test_id", "records", "device", "scene"]);

      await this.options_data_old_api([
        "test_id",
        "records",
        "device",
        "scene"
      ]);

      this.source_api();
      this.memory_detail_api();
      // this.old_test_class=this.memoryList.length>1?this.memoryList[1].id_test:this.memoryList[0].id_test;
      await this.getSpeedmFilenameList();
      this.fileName = this.memoryFileList[0]
      this.saveToLocalStorage();
      this.mem_api();
      //  this.mod_list_api();
      //       this.mod_res_api()

      // this.mod_res_api()
      this.mod_api();
      this.res_data_api();
      this.file_data_api();
      this.resTrend_api();
      this.memoryTrend_api();
    },

    async getMemSummaryListV1() {
      const { data } = await gtAxios({
        url: "/memory/mem_summary_list_v1/",
        params: {
          project: this.localProject,
          id_test: this.id_test,
          old_test: this.old_test
        }
      });
      this.mem_list = data.map(item => {
        item.rowKey = Math.random()
        return item
      });
    },

    async mem_api() {
      await this.getMemSummaryListV1();
      this.mem_loading = false;
    },

    sortFun(attr, rev) {
      //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
      }
      return function (a, b) {
        a = a[attr];
        b = b[attr];
        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      };
    },

    async options_data_api(data, type, isInit) {
      // 等待第一个异步操作完成
      if (data.includes("test_id")) {
        const record_list = await this.getSpeedmMemoryRecords(this.date);
        this.record_list = record_list;
        if (record_list.length > 0) {
          if (type) {
            this.record_id = this.formDataOverview.record_id
              ? Number(this.formDataOverview.record_id)
              : record_list[0].record_id;
          } else {
            this.record_id = record_list[0].record_id;
          }
        }
      }

      this.changeForm(isInit);

      if (data.includes("records")) {
        const version_list = await this.getSpeedmMemoryVersions(this.record_id, this.date);
        this.sceneList = version_list;
        if (version_list.length > 0) {
          if (type) {
            this.version = this.formDataOverview.version
              ? this.formDataOverview.version
              : version_list[0].version;
          } else {
            this.version = version_list[0].version;
          }
        }
      }

      this.changeForm(isInit);

      // 假设record_list始终有元素
      if (data.includes("device")) {
        const device_list = await this.getSpeedmMemoryDevices(this.version, this.record_id, this.date);
        this.device_list = device_list;
        // 假设device_list始终有元素
        if (device_list.length > 0) {
          if (type) {
            if (device_list.some((device) => device.device_id == 5488)) {
              this.device_id = this.formDataOverview.device_id
                ? Number(this.formDataOverview.device_id)
                : 5488;
            } else {
              this.device_id = this.formDataOverview.device_id
                ? Number(this.formDataOverview.device_id)
                : device_list[0].device_id;
            }
          } else {
            if (device_list.some((device) => device.device_id == 5488)) {
              this.device_id = 5488;
            } else {
              this.device_id = device_list[0].device_id;
            }
          }
        }
      }

      this.changeForm(isInit);
      // 等待第二个异步操作完成

      // 等待第三个异步操作完成
      if (data.includes("scene")) {
        const scene_list = await this.getSpeedmMemoryScenes(
          this.version,
          this.record_id,
          this.device_id,
          this.date
        );
        this.scene_list = scene_list;
        // 假设scene_list始终有元素

        if (scene_list.length > 0) {
          if (type) {
            if (
              scene_list.some((device) => device.scene_name == "InBigWorld_All")
            ) {
              this.scene_name = this.formDataOverview.scene_name
                ? this.formDataOverview.scene_name
                : "InBigWorld_All";
            } else {
              this.scene_name = this.formDataOverview.scene_name
                ? this.formDataOverview.scene_name
                : scene_list[0].scene_name;
            }
          } else {
            if (
              scene_list.some((device) => device.scene_name == "InBigWorld_All")
            ) {
              this.scene_name = "InBigWorld_All";
            } else {
              this.scene_name = scene_list[0].scene_name;
            }
          }
        }
      }

      this.changeForm(isInit);

      // 等待第四个异步操作完成
      const res = await this.getSpeedmMemoryId(
        this.version,
        this.record_id,
        this.device_id,
        this.scene_name,
        this.date
      );
      this.speedmMemoryData = res
      this.id_test = res.id_test;

      // 如果没有使用try/catch，你需要在其他地方处理错误
      // 例如，你可能希望在某些全局错误处理程序中处理这些错误
    },

    mod_summary() {
      this.mod_summary_table = [];
      this.modListData.mod_summary.module_list.forEach((v) => {
        this.mod_summary_table.push({
          name: v,
          data: this.modListData.mod_summary.data
        });
      });
    },

    async options_data_old_api(data, type, isInit) {
      // 等待第一个异步操作完成
      if (data.includes("test_id")) {
        const record_list = await this.getSpeedmMemoryRecords(this.old_date);
        this.record_list_old = record_list;
        if (record_list.length > 0) {
          if (type) {
            this.record_id_old = this.formDataOverview.record_list_old
              ? this.formDataOverview.record_list_old
              : record_list[0].record_id;
          } else {
            this.record_id_old = record_list[0].record_id;
          }
        }
      }

      this.changeForm(isInit);

      if (data.includes("records")) {
        const version_list = await this.getSpeedmMemoryVersions(this.record_id_old, this.old_date);
        this.sceneOldList = version_list;
        if (version_list.length > 0) {
          if (type) {
            this.old_version = this.formDataOverview.old_version
              ? this.formDataOverview.old_version
              : version_list[0].version;
          } else {
            this.old_version = version_list[0].version;
          }
        }
      }
      // 假设record_list始终有元素

      this.changeForm(isInit);

      // 等待第二个异步操作完成
      if (data.includes("device")) {
        const device_list = await this.getSpeedmMemoryDevices(this.old_version, this.record_id_old, this.old_date);
        this.device_list_old = device_list;
        // 假设device_list始终有元素
        if (device_list.length > 0) {
          if (type) {
            if (device_list.some((device) => device.device_id == 5488)) {
              this.device_id_old = this.formDataOverview.device_list_old
                ? Number(this.formDataOverview.device_list_old)
                : 5488;
            } else {
              this.device_id_old = this.formDataOverview.device_list_old
                ? Number(this.formDataOverview.device_list_old)
                : device_list[0].device_id;
            }
          } else {
            if (device_list.some((device) => device.device_id == 5488)) {
              this.device_id_old = 5488;
            } else {
              this.device_id_old = device_list[0].device_id;
            }
          }
        }
      }

      this.changeForm(isInit);

      // 等待第三个异步操作完成
      if (data.includes("scene")) {
        const scene_list = await this.getSpeedmMemoryScenes(
          this.old_version,
          this.record_id_old,
          this.device_id_old,
          this.old_date
        );
        this.scene_list_old = scene_list;

        // 假设scene_list始终有元素
        if (scene_list.length > 0) {
          if (type) {
            if (
              scene_list.some((device) => device.scene_name == "InBigWorld_All")
            ) {
              this.scene_name_old = this.formDataOverview.scene_list_old
                ? this.formDataOverview.scene_list_old
                : "InBigWorld_All";
            } else {
              this.scene_name_old = this.formDataOverview.scene_list_old
                ? this.formDataOverview.scene_list_old
                : scene_list[0].scene_name;
            }
          } else {
            if (
              scene_list.some((device) => device.scene_name == "InBigWorld_All")
            ) {
              this.scene_name_old = "InBigWorld_All";
            } else {
              this.scene_name_old = scene_list[0].scene_name;
            }
          }
        }
      }

      this.changeForm(isInit);

      // 等待第四个异步操作完成
      const res = await this.getSpeedmMemoryId(
        this.old_version,
        this.record_id_old,
        this.device_id_old,
        this.scene_name_old,
        this.old_date
      );
      this.old_test = res.id_test;

      // 如果没有使用try/catch，你需要在其他地方处理错误
      // 例如，你可能希望在某些全局错误处理程序中处理这些错误
    },

    getColor(size) {
      if (this.size_value) {
        if (this.size_value < Math.abs(size) / 1024 / 1024) {
          return "color:red";
        } else {
          return "color:''";
        }
      }
    },
    getColor_1(size) {
      if (size) {
        if (Math.abs(size) / 1024 / 1024 > 1) {
          return "color:red";
        } else {
          return "color:''";
        }
      } else {
        return "color:''";
      }
    },
    getColor_config_size(size, value) {
      if (size) {
        if (Math.abs(size) / 1024 / 1024 > value) {
          return "color:red";
        } else {
          return "color:''";
        }
      } else {
        return "color:''";
      }
    },
    getColor_config_size2(size, value) {
      if (size) {
        if (Math.abs(size) / 1024 > value) {
          return "color:red";
        } else {
          return "color:''";
        }
      } else {
        return "color:''";
      }
    },
    getCount(count) {
      if (this.count_value) {
        if (this.count_value < Math.abs(count)) {
          return "color:red";
        } else {
          return "color:''";
        }
      }
    },
    getColor_config_count(count, value) {
      if (count) {
        if (value < Math.abs(count)) {
          return "color:red";
        } else {
          return "color:''";
        }
      }
    },
    getCount_10(count) {
      if (count) {
        if (Math.abs(count) > 10) {
          return "color:red";
        } else {
          return "color:''";
        }
      } else {
        return "color:''";
      }
    },
    sort_change(column) {
      let form = {};

      this.currentPage = 1;
      console.log(column);
      this.resData.top_list.sort(
        this.sortFun(column?.prop, column?.order === "ascending")
      );
      this.res_detail_table = this.resData.top_list.slice(
        (this.currentPage - 1) * this.size,
        this.currentPage * this.size
      );
    },
    exportTable() {
      this.exportToCSV();
      this.exportToCSV_two();
    },
    mode_sort_change(column) {
      let form = {};

      this.currentPage_mod = 1;
      this.mod_data.sort(
        this.sortFun(column?.prop, column?.order === "ascending")
      );
      this.mode_current_change();
    },
    file_sort_change(column) {
      let form = {};

      this.file_currentPage = 1;
      console.log(column);
      this.fileData.top_list.sort(
        this.sortFun(column?.prop, column?.order === "ascending")
      );
      this.file_detail_table = this.fileData.top_list.slice(
        (this.file_currentPage - 1) * this.file_size,
        this.file_currentPage * this.file_size
      );
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      //指定坐标rowIndex ：行，columnIndex ：列
      if (columnIndex === 0) {
        return { background: this.colors[rowIndex], color: "#fff" }; //rgb(105,0,7)
      }
    },

    drawResTrendMod() {
      let data = [];

      this.modTrendData.module_list.forEach((v, index) => {
        data.push({
          name: v,
          type: "line",
          symbol: "circle", //拐点设置为实心
          data: this.modTrendData.series[index]
        });
      });

      let performance_line = document.getElementById("mod_trend");
      echarts.dispose(performance_line);
      var contrastChart = echarts.init(performance_line);
      contrastChart.setOption({
        color: this.colors,
        tooltip: {
          trigger: "axis"
        },

        legend: {
          type: "scroll",
          x: "center",
          y: "bottom",
          padding: [0, 0, 10, 0]
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: function (value) {
              return value + "MB"; // 在数值后添加"MB"单位
            }
          }
          // ...其他配置项
        },
        grid: {
          left: "4%",
          top: "10%",
          bottom: "10%",
          right: "4%",
          containLabel: true
        },
        animation: false,
        xAxis: {
          type: "category",
          data: this.modTrendData.date_list
        },

        series: data
      });
    },
    drawMemoryTrend() {
      let data = [];

      this.memoryTrendData.module_list.forEach((v, index) => {
        data.push({
          name: v,
          type: "line",
          symbol: "circle", //拐点设置为实心
          data: this.memoryTrendData.series[index]
        });
      });

      let performance_line = document.getElementById("file_trend");
      echarts.dispose(performance_line);
      var contrastChart = echarts.init(performance_line);
      contrastChart.setOption({
        color: this.colors,
        tooltip: {
          trigger: "axis"
        },

        legend: {
          type: "scroll",
          x: "center",
          y: "bottom",
          padding: [0, 0, 10, 0]
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: function (value) {
              return value + "MB"; // 在数值后添加"MB"单位
            }
          }
          // ...其他配置项
        },
        grid: {
          left: "4%",
          top: "10%",
          bottom: "10%",
          right: "4%",
          containLabel: true
        },
        animation: false,
        xAxis: {
          type: "category",
          data: this.memoryTrendData.date_list
        },

        series: data
      });
    },
    drawResPie() {
      let performance_line = document.getElementById("res");
      echarts.dispose(performance_line);
      var contrastChart = echarts.init(performance_line);
      contrastChart.setOption({
        title: {
          text: "总大小" + this.sizeCompany(this.resData.list["本次数据"].sum),

          left: "center"
        },
        color: this.colors,
        animation: false,
        // backgroundColor: 'rgb(13, 13, 13)',
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            var str = "";
            //首先要看看params是怎样的数据结构，里面有什么内容;

            //对params进行操作
            return (
              params.data.name +
              ":" +
              this.sizeCompany(params.data.value) +
              "(" +
              params.percent +
              "%)"
            );
          }
        },

        series: [
          {
            type: "pie",
            radius: "80%",
            center: ["50%", "58%"], // 调整饼图的位置
            data: this.resPieData.map((item) => {
              if (item.name === "其他") {
                // 设置特定的背景色
                return {
                  ...item,
                  itemStyle: {
                    color: "gray"
                  }
                };
              }
              return item;
            }),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            },
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{d}%",
                  position: "inside",
                  color: "#fff"
                },
                labelLine: { show: false }
              }
            }
          }
        ]
      });
    },

    formattedChange(change, type) {
      if (change > 0) {
        return type ? this.sizeCompany_table(change) + "↑" : change + "↑";
      } else if (change < 0) {
        return type
          ? this.sizeCompany_table(change) + "↓"
          : Math.abs(change) + "↓";
      } else {
        return type ? this.sizeCompany_table(change) : change;
      }
    },
    drawResPieMod() {
      let performance_line = document.getElementById("mod");
      echarts.dispose(performance_line);
      var contrastChart = echarts.init(performance_line);
      contrastChart.setOption({
        title: {
          text: "总大小" + this.sizeCompany(this.mod_num),

          left: "center"
        },
        color: this.colors,
        animation: false,
        // backgroundColor: 'rgb(13, 13, 13)',
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            var str = "";
            //首先要看看params是怎样的数据结构，里面有什么内容;

            //对params进行操作
            return (
              params.data.name +
              ":" +
              this.sizeCompany(params.data.value) +
              "(" +
              params.percent +
              "%)"
            );
          }
        },

        series: [
          {
            type: "pie",
            radius: "80%",
            center: ["50%", "58%"], // 调整饼图的位置
            data: this.modPieData.map((item) => {
              if (item.name === "其他") {
                // 设置特定的背景色
                return {
                  ...item,
                  itemStyle: {
                    color: "gray"
                  }
                };
              }
              return item;
            }),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            },
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{d}%",
                  position: "inside",
                  color: "#fff"
                },
                labelLine: { show: false }
              }
            }
          }
        ]
      });
    },

    drawResTrend() {
      let data = [];

      this.resTrendData.module_list.forEach((v, index) => {
        data.push({
          name: v,
          type: "line",
          symbol: "circle", //拐点设置为实心
          data: this.resTrendData.series[index]
        });
      });

      let performance_line = document.getElementById("res_trend");
      echarts.dispose(performance_line);
      var contrastChart = echarts.init(performance_line);
      contrastChart.setOption({
        color: this.colors,
        tooltip: {
          trigger: "axis"
        },

        legend: {
          type: "scroll",
          x: "center",
          y: "bottom",
          padding: [0, 0, 10, 0]
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: function (value) {
              return value + "MB"; // 在数值后添加"MB"单位
            }
          }
          // ...其他配置项
        },
        grid: {
          left: "4%",
          top: "10%",
          bottom: "10%",
          right: "4%",
          containLabel: true
        },
        animation: false,
        xAxis: {
          type: "category",
          data: this.resTrendData.date_list
        },

        series: data
      });
    },

    async putMemoryConfig() {
      await gtAxios({
        method: "put",
        url: "/memory/memory_config/",
        data: {
          project: this.localProject,
          key: "resource_memory",
          value: {
            change_size: this.dialogConfigData.change_size,
            count: this.dialogConfigData.count,
            change_count: this.dialogConfigData.change_count,
            size: this.dialogConfigData.size
          }
        }
      });
      await this.sleep(500);
    },

    openConfig(type) {
      if (type == "open") {
        this.dialog_config = true;
      } else {
        this.dialog_config = false;
        this.dialogConfigData_change.size = this.dialogConfigData.size;
        this.dialogConfigData_change.count = this.dialogConfigData.count;
        this.dialogConfigData_change.change_size = this.dialogConfigData.change_size;
        this.dialogConfigData_change.change_count = this.dialogConfigData.change_count;
        this.putMemoryConfig();
      }
    },
    drawFilePie() {
      let performance_line = document.getElementById("file");
      echarts.dispose(performance_line);
      var contrastChart = echarts.init(performance_line);
      contrastChart.setOption({
        title: {
          text: "总大小" + this.sizeCompany(this.fileData.list["本次数据"].sum),

          left: "center"
        },
        color: this.colors,
        animation: false,
        // backgroundColor: 'rgb(13, 13, 13)',
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            var str = "";
            //首先要看看params是怎样的数据结构，里面有什么内容;

            //对params进行操作
            return (
              params.data.name +
              ":" +
              this.sizeCompany(params.data.value) +
              "(" +
              params.percent +
              "%)"
            );
          }
        },

        series: [
          {
            type: "pie",
            radius: "80%",
            center: ["50%", "58%"], // 调整饼图的位置
            data: this.fulePieData.map((item) => {
              if (item.name === "其他") {
                // 设置特定的背景色
                return {
                  ...item,
                  itemStyle: {
                    color: "gray"
                  }
                };
              }
              return item;
            }),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            },
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{d}%",
                  position: "inside",
                  color: "#fff"
                },
                labelLine: { show: false }
              }
            }
          }
        ]
      });
    },

    sizeCompany(item) {
      if (String(item) != "") {
        if (Number(item) < 1024) {
          return String(item) + "B";
        }
        if (Number(item) >= 1024 && Number(item) < 1024 * 1024) {
          return (Number(item) / 1024).toFixed(1) + "KB";
        }
        if (Number(item) >= 1024 * 1024 && Number(item) < 1024 * 1024 * 1024) {
          return (Number(item) / 1024 / 1024).toFixed(1) + "MB";
        }
        if (Number(item) >= 1024 * 1024 * 1024) {
          return (Number(item) / 1024 / 1024 / 1024).toFixed(1) + "GB";
        }
      } else {
        return "";
      }
    },
    sizeCompany_table(item) {
      if (String(item) != "") {
        let num = Math.abs(item);
        if (Number(num) < 1024) {
          return String(num) + "B";
        }
        if (Number(num) >= 1024 && Number(num) < 1024 * 1024) {
          return (Number(num) / 1024).toFixed(1) + "KB";
        }
        if (Number(num) >= 1024 * 1024 && Number(num) < 1024 * 1024 * 1024) {
          return (Number(num) / 1024 / 1024).toFixed(1) + "MB";
        }
        if (Number(num) >= 1024 * 1024 * 1024) {
          return (Number(num) / 1024 / 1024 / 1024).toFixed(1) + "GB";
        }
      } else {
        return "";
      }
    },

    handleBlur(type) {
      if (type == "size") {
        if (this.detail_size) {
          if (isNaN(Number(this.detail_size))) {
            ElMessage.error("请输入数字");
          } else {
            this.size_value = this.detail_size;
          }
        } else {
          this.size_value = this.detail_size;
        }
      } else {
        if (this.detail_count) {
          if (isNaN(Number(this.detail_count))) {
            ElMessage.error("请输入数字");
          } else {
            this.count_value = this.detail_count;
          }
        } else {
          this.count_value = this.detail_count;
        }
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row.text === row.version) {
          return [1, 2]; // 合并两列
        }
      }
      if (columnIndex === 1) {
        if (row.text === row.version) {
          return [0, 0]; // 合并两列
        }
      }
      return [1, 1]; // 不合并
    },

    checkBtn(name) {
      this.tableAddShow = true;
      this.checkCol = [];
      this.checkDetailList = [];
      this.checkTable = [];
      this.resSummaryList.date_list.forEach((v) => {
        this.checkDetailList = this.resSummaryList.data[v][name].detail_list;
        this.checkCol.push({
          version: v,
          [v]: this.resSummaryList.data[v][name].Detail
        });
      });
      this.checkDetailList.forEach((v) => {
        this.checkTable.push({
          name: v,
          data: this.checkCol
        });
      });
    },

    scrollBtn(item) {
      const targetElement = document.querySelector("#" + item);

      targetElement.scrollIntoView();
    },

    fileTable() {
      this.file_table_list = [];
      for (let i in this.fileData?.list) {
        this.file_table_list.push({
          text: i,
          version:
            i == "对比数据"
              ? "对比数据"
              : i == "对比版本"
              ? this.old_version
              : this.version,
          sum: this.fileData?.list[i]["资源大小"],
          top: this.fileData?.list[i]["资源数量"],
          proportion:
            i == "对比数据"
              ? this.fileData?.list[i].risk
              : this.fileData?.list[i]["平均大小"]
        });
      }
    },

    get_old_version() {
      let num = 0;

      if (this.date_list.length > 1) {
        if (this.date_list[this.date_list.length - 1] == this.date) {
          this.date_list.forEach((v, index) => {
            if (v == this.date) {
              num = index;
            }
          });
          this.old_date = this.date_list[num - 1];
        } else {
          this.date_list.forEach((v, index) => {
            if (v == this.date) {
              num = index;
            }
          });
          this.old_date = this.date_list[num + 1];
        }
      } else {
        this.old_date = this.date_list[0];
      }
    },

    res_current_change() {
      this.res_detail_table = this.resData.top_list.slice(
        (this.currentPage - 1) * this.size,
        this.currentPage * this.size
      );
    },

    file_current_change() {
      this.file_detail_table = this.fileData.top_list.slice(
        (this.file_currentPage - 1) * this.file_size,
        this.file_currentPage * this.file_size
      );
    },
    mode_current_change() {
      this.mod_table = this.mod_data?.slice(
        (this.currentPage_mod - 1) * this.size_mod,
        this.currentPage_mod * this.size_mod
      );
    },

    async res_data_api() {
      await this.getResSummary();

      // this.resTable();
      this.currentPage = 1;
      this.res_detail_table = this.resData.top_list.slice(
        (this.currentPage - 1) * this.size,
        this.currentPage * this.size
      );
      await this.get_res_pie();
      this.drawResPie();
      this.resLoading = false;
      if (this.$route.query.scroll) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$route.query.scroll == "memory") {
              this.scrollBtn("detail_scroll");
            } else if (this.$route.query.scroll == "module") {
              this.scrollBtn("memory_scroll");
            }
          }, 1000); // 在 $nextTick 内使用 setTimeout 来确保在 DOM 更新后执行
        });
      }
    },

    async file_data_api() {
      await this.getSpeedmMemorySummary();
      this.fileTable();
      this.file_currentPage = 1;
      this.file_detail_table = this.fileData.top_list.slice(
        (this.file_currentPage - 1) * this.file_size,
        this.file_currentPage * this.file_size
      );
      await this.get_file_pie();
      this.drawFilePie();

      this.fileLoading = false;
    },
    get_res_pie() {
      this.resPieData = [];
      let num = 0;
      this.resData["全量饼图"].forEach((v) => {
        num += v.size;
      });

      if (num == this.resData.list["本次数据"].sum) {
        this.resData["全量饼图"].forEach((v) => {
          this.resPieData.push({ name: v.name, value: v.size });
        });
      } else {
        this.resData["全量饼图"].forEach((v) => {
          this.resPieData.push({ name: v.name, value: v.size });
        });
        let nullData = this.resData.list["本次数据"].sum - num;
        this.resPieData.push({ name: "其他", value: nullData });
      }
    },
    get_mode_pie() {
      this.modPieData = [];
      this.mod_num = 0;
      this.mod_data.forEach((v) => {
        this.mod_num += v.size;
      });

      this.mod_data.forEach((v) => {
        this.modPieData.push({ name: v.module, value: v.size });
      });
    },

    get_file_pie() {
      this.fulePieData = [];
      let num = 0;
      this.fileData["全量饼图"].forEach((v) => {
        num += v.size;
      });

      if (num == this.fileData.list["本次数据"].sum) {
        this.fileData["全量饼图"].forEach((v) => {
          this.fulePieData.push({ name: v.name, value: v.size });
        });
      } else {
        this.fileData["全量饼图"].forEach((v) => {
          this.fulePieData.push({ name: v.name, value: v.size });
        });
        let nullData = this.fileData.list["本次数据"].sum - num;
        this.fulePieData.push({ name: "其他", value: nullData });
      }
    },

    async resTrend_api() {
      await this.getSpeedmMemoryResTrend("ResSummary");
      this.drawResTrend();
      this.res_loading = false;
    },

    beforeUpload(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let isLt2M = file.size / 1024 / 1024 / 1024 < 2;
      if (["log"].indexOf(extension) === -1) {
        ElMessage.error({
          message: "只能上传后缀是.log的文件",
          showClose: true,
          type: "error"
        });
        this.$refs["upload"].clearFiles();
      }
      if (!isLt2M) {
        ElMessage.error({
          message: "上传文件大小不能超过2GB!",
          showClose: true,
          type: "error"
        });
        this.$refs["upload"]?.clearFiles();
      }
      return extension && isLt2M;
    },
    beforeUpload_result(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let isLt2M = file.size / 1024 / 1024 / 1024 < 2;
      if (["zip"].indexOf(extension) === -1) {
        ElMessage.error({
          message: "只能上传后缀是.log的文件",
          showClose: true,
          type: "error"
        });
        this.$refs["upload"].clearFiles();
      }
      if (!isLt2M) {
        ElMessage.error({
          message: "上传文件大小不能超过2GB!",
          showClose: true,
          type: "error"
        });
        this.$refs["upload"]?.clearFiles();
      }
      return extension && isLt2M;
    },

    async getSpeedModSummaryV1(order_by) {
      const { data } = await gtAxios({
        url: "/memory/mod_res_summary_list_v1/",
        params: {
          project: this.localProject,
          id_test: this.id_test,
          old_test: this.old_test,
          order_by,
          reverse: this.sort_reverse_v1
        }
      });
      this.memory_detail_list = data.map(item => {
        item.rowKey = Math.random()
        return item
      });
    },

    async sort_change_v1(column) {
      this.sort_param_v1 = column.prop ? column.prop : "";
      this.sort_reverse_v1 = column.order
        ? column?.order == "ascending"
          ? 0
          : 1
        : "";
      await this.getSpeedModSummaryV1(this.sort_param_v1);
      this.momory_loading_v1 = false;
    },
    

    async memoryTrend_api() {
      await this.getSpeedmMemoryResTrend(this.fileName);
      this.drawMemoryTrend();
      this.memory_loading = false;
    },

    exportToCSV() {
      this.$nextTick(() => {
        var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换，保证时间格式或者较长数字不会出现科学计数法。（这个很关键）
        var wb = XLSX.utils.table_to_book(
          document.querySelector("#detailTable"),
          xlsxParam
        );
        /* 获取二进制字符串作为输出 */
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          fileSaver?.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            //设置导出文件名称
            "测试用例和时间(1)" + ".csv"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }

        return wbout;
      });
    },
    exportToCSV_two() {
      this.$nextTick(() => {
        var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换，保证时间格式或者较长数字不会出现科学计数法。（这个很关键）
        var wb = XLSX.utils.table_to_book(
          document.querySelector("#detailTable_two"),
          xlsxParam
        );
        /* 获取二进制字符串作为输出 */
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          fileSaver?.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            //设置导出文件名称
            "测试用例和时间(2)" + ".csv"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }

        return wbout;
      });
    },
    fixedActiveBtn() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      scrollTop >= 62 ? (this.fixed = true) : (this.fixed = false);

      if (this.fixed == true) {
        document
          .getElementsByClassName("el-menu")[0]
          .setAttribute(
            "style",
            "position:fixed;width: 220px;top:0px;background-color:#545c64;border: 0; overflow-x: hidden;"
          );
      } else {
        document
          .getElementsByClassName("el-menu")[0]
          .setAttribute(
            "style",
            `position:fixed;width: 220px;top:${
              62 - scrollTop
            };background-color:#545c64;border: 0;`
          );
      }
    },
    

    async getDeviceSpecs() {
      const { data } = await gtAxios({
        url: "/device/device_specs/",
        params: {
          project: this.localProject
        }
      });
      this.DeviceSpecs = data;
    },

    async getSimpleScripts() {
      gtAxios({
        url: "/task/simple_scripts/",
        params: {
          project: this.localProject
        }
      });
    },

    

    fileChange() {
      this.fileLoading = true;
      this.memory_loading = true;
      this.file_page = 1;
      this.file_record = 20;
      this.saveToLocalStorage();
      this.file_data_api();
      this.memoryTrend_api();
    },
    scroll_detail(item) {
      this.scrollBtn("detail_scroll");
      this.fileName = item;

      setTimeout(() => {
        this.fileChange();
      }, 1000); // 可以适当调整延迟时间
    },
    async versionChange(type) {
      if (type) {
        const { data } = await gtAxios({
          url: `/memory/speedm_memory_list/`,
          params: {
            project: this.localProject,
            scene_name: this.scene_name,
            device_id: this.device_id
          }
        });

        this.memoryList = data;
        this.id_test = this.memoryList[0].id_test;
      }
    },
    same(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (!newValue && !oldValue) {
          return "font-weight: normal";
        } else {
          return "font-weight: bold";
        }
      }
    },
    sameSizeCount(changeValue, type) {
      if (type == "size") {
        if (changeValue) {
          if (Math.abs(changeValue) / 1024 / 1024 <= 1) {
            return "font-weight: bold";
          } else {
            return "font-weight: normal";
          }
        } else {
          return "font-weight: normal";
        }
      } else {
        if (changeValue) {
          if (Math.abs(changeValue) <= 10) {
            return "font-weight: bold";
          } else {
            return "font-weight: normal";
          }
        } else {
          return "font-weight: normal";
        }
      }
    },
    async confirm() {
      this.changeQuery();

      this.resLoading = true;
      this.fileLoading = true;
      this.mem_loading = true;
      this.momory_loading_v1 = true;
      this.summary_table_loading = true;
      this.memory_loading = true;
      this.size_value = 1;
      this.count_value = 10;
      this.detail_size = 1;
      this.detail_count = 10;
      this.modLoading = true;
      this.mod_loading = true;
      this.summary_res_table_loading = true;
      this.current_page = 1;
      this.record = 20;
      this.file_page = 1;
      this.file_record = 20;
      this.size_mod = 10;
      this.currentPage_mod = 1;
      this.mod_page = 1;
      this.mod_size = 20;
      this.res_page = 1;
      this.res_size = 20;
      this.res_page_v1 = 1;
      this.res_size_v1 = 20;
      this.source_size = 20;
      this.source_page = 1;
      this.source_loading = true;
      this.valueTime = [];
      this.source_api();
      this.memory_detail_api();

      await this.getSpeedmFilenameList();
      this.fileName = this.memoryFileList[0]
      this.saveToLocalStorage();

      this.mem_api();
      this.mod_api();
      this.res_data_api();
      this.file_data_api();
      this.resTrend_api();
      this.memoryTrend_api();
    },

    async memory_detail_api() {
      await this.getSpeedModSummaryV1("");
      this.momory_loading_v1 = false;
    },

    class_change() {
      this.modLoading = true;
      this.mod_loading = true;
      this.mod_api();
    },

    async getSpeedmModTrend() {
      const { data } = await gtAxios({
        url: "/memory/mod_summary_trend/",
        params: {
          project: this.localProject,
          scene_name: this.scene_name
        }
      });
      this.modTrendData = data;
    },

    async mod_api() {
      await this.getSpeedModSummary();
      if (this.mod_data.length > 0) {
        this.mode_current_change();
        this.get_mode_pie();
        this.$nextTick(() => {
          this.drawResPieMod();
        });
      }

      this.modLoading = false;
      await this.getSpeedmModTrend();

      if (this.mod_data.length > 0) {
        this.$nextTick(() => {
          this.drawResTrendMod();
        });
      }

      this.mod_loading = false;
    },

    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
      if (!this.isNavOpen) {
        const navList = document.getElementById("nav-list");
      }
    }
  }
};
</script>

<style scoped>
.w-100px {
  width: 100px;
}

.nav-container {
  position: fixed;
  z-index: 2000;
  width: 200px;
  height: 120px;
  top: 50%; /* 定位到父元素的50%位置 */
  margin-left: 30px;
  transform: translateY(-50%); /* 使用负偏移的transform将元素在垂直方向上居中 */
}

.nav-button {
  width: 50px;
  height: 120px;
  background-color: #3498db;
  color: white;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  writing-mode: vertical-rl;
  cursor: pointer;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 999;
}

.nav-list {
  position: absolute;
  left: 25px;
  top: 0px;
  font-size: 12px;
  width: 100px;
  height: 120px;
  background-color: #f1f1f1;
  border: 1px solid #ddd;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  padding: 10px;
  border-radius: 5px;
  z-index: -1;
  box-sizing: border-box;
  padding-left: 25px;
  transition: all 1s;
  font-weight: bold;
  transition: opacity 1s, visibility 1s;
  opacity: 0;
}
.nav-list.active {
  opacity: 1;
  width: 100px;
  visibility: visible;
}
.nav-list-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  justify-content: space-around;
}
.nav-list-box div {
  cursor: pointer;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s;
}

.slide-enter, .slide-leave-to /* .slide-leave-active in <2.1.8 */ {
  transform: translateX(-100%);
  opacity: 0;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

li {
  margin: 10px 0;
}

.bold {
  font-weight: bold;
}
a {
  color: #61c3e4;
}
/* .res_list .margin_div {
  margin-right: 10px;
  width: 100px;
} */
.img_border {
  padding: 4px;
  border-radius: 4px;
}
.gallery__big {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(9, 11, 24, 0.9);
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.gallery__big_box {
  position: absolute;
  top: 11.1%;
  bottom: 23.1%;
  left: 8.3%;
  right: 8.3%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gallery__big_wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.text_blue {
  color: rgb(93, 153, 213);
  font-weight: bold;
}
.Ecard {
  width: 1260px;
  margin: 0 auto;
  background-color: white;
  box-shadow: 0 2px 10px rgb(179 186 220 / 40%);
  font-size: 15px;
}
.Ecard .testMain {
  padding: 30px;
}
.Ecard .banner {
  width: 100%;
}
/* 版本 */
.versionGeneration2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.versionGeneration p {
  margin-top: 10px !important;
  line-height: 32px;
}
.versionGeneration .copyVal {
  display: flex;
  justify-content: end;
}
.mainContent {
  width: 97%;
  margin: 0 auto;
}
/* 核心指标风险详情表格 */
.gameTable {
  width: 100%;
  background-color: #f5f7fa;
  border: 1px solid #e2e7eb;
  border-collapse: collapse;
  font-size: 13px;
}
.gameTable .gameIcon {
  width: 93px;
  text-align: center;
}
.gameTable .gameIcon img {
  width: 95%;
}
.gameTable span {
  font-weight: normal;
  /* font-size:14px; */
}
.gameTable td {
  border: 1px solid #e2e7eb;
  height: 31px;
  white-space: nowrap;
  font-weight: bold;
}
.gameTable tr:nth-of-type(n + 2) td {
  text-indent: 8px;
}

.gameTable .game_name,
.gameTable .com_risk_green,
.gameTable .com_risk_red {
  font-weight: bold;
}
.gameTable .com_risk_red {
  color: red;
}
.gameTable .com_risk_green {
  color: #00b050;
}
/* 核心指标风险结论 */
.conclusion div {
  margin-left: 11px;
  color: #303133;
}
.conclusion ul {
  padding: 0;
  list-style-type: none;
  margin: 5px 0;
}
.conclusion p {
  font-weight: 550;
  font-size: 15px;
}

/* FPS趋势图 */
.FPStrend {
  margin-bottom: 20px;
  /*height: 350px;*/
}
.FPStrend .labelStyle {
  text-align: left;
  margin-bottom: 5px;
  font-weight: 550;
}

/* 详细测试数据 */
.detailedTest .describe {
  font-size: 15px;
}
.detailedTest .describe span {
  background-color: #e7e6e6;
}
.detailedTestTable #Table_Right_div {
  overflow-x: auto;
  width: 928px;
}
.outerLayerTable .Table_Left td,
.outerLayerTable .Table_Right_in td {
  height: 31px;
  border-collapse: collapse;
  font-size: 12px;
  white-space: nowrap;
  text-align: center;
  border-bottom: 1px solid #e2e7eb;
  border-right: 1px solid #e2e7eb;
  padding: 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.outerLayerTable .Table_Left {
  width: 237px;
  max-width: 320px;
}
.outerLayerTable .Table_Left,
.outerLayerTable .Table_Right_in tr:nth-child(-n + 2) {
  background-color: #5d99d5;
  color: white;
  font-weight: bold;
}
.outerLayerTable2 .Table_Left,
.outerLayerTable2 .Table_Right_in tr:nth-child(-n + 2) {
  background-color: #5957b1 !important;
}
.outerLayerTable2 .Table_Right_in tr:nth-child(n + 3) td:nth-child(2) {
  background-color: #cccccc;
}
.outerLayerTable2 .Table_Right_in tr:nth-child(n + 3) td:first-child {
  background-color: #ffffff !important;
  color: #4659b8;
}
.Table_Right_in tr:nth-child(n + 3) td:first-child {
  background-color: #cccccc;
}
.outerLayerTable .Table_Right_in {
  table-layout: fixed;
}
.outerLayerTable .Table_Left table {
  width: 100%;
}
.outerLayerTable .scrollTD {
  display: none;
}
.outerLayerTable .scrollTD2 {
  height: 18px !important;
}
.memory_flex {
  display: flex;
  padding: 10px 0px;
}
.memory_margin_row {
  display: block;
}
.memory_margin_Format {
  display: block;
}
.memory_margin_row_count {
  display: block;
}
/* 底部 */
.footer {
  background-color: #eff4fa;
  width: 100%;
  height: 31px;
  text-align: center;
}


.type-table :deep(.el-table__row td:nth-child(2)) {
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

.el-form-item /deep/ .el-form-item__label {
  font-weight: normal;
}

.el-form-item /deep/ .el-select {
  max-width: 180px;
}

.h5, h5 {
  font-weight: 500;
  font-size: 1.25rem;
}

.h6, h6 {
  font-size: 1rem;
}

.TitleStyle span {
  width: 6px;
  height: 15px;
  background-color: #2b64bb;
  margin-right: 5px;
  display: inline-block;
}

.spacName {
  margin: 20px 0 40px 0;
}

.el-form--inline.el-form--label-top {
  display: flex;
}

.detail-body {
  flex-grow: 1;
  overflow: hidden;
  padding: 20px 100px;
  background-color: #f5f6fa;
}
</style>

<style>
/* 核心指标风险详情 */
/* .banner_btn .el-dialog{
  height:90% !important
} */
.banner_btn .el-dialog__body {
  overflow-y: auto;
  height: 800px !important;
}
.banner_btn .el-dialog__footer {
  height: 70px !important;
}
.corePerformance_in .el-table thead {
  color: #303133;
}
.corePerformance_in .el-table td,
.corePerformance_in .el-table th {
  height: 31px;
  padding: 0;
}
.corePerformance_in .el-table {
  margin-bottom: 20px;
  font-size: 13px;
}
.versionGeneration .iTemWidth .el-form-item__content {
  width: 150px !important;
}
.versionGeneration .iTemWidth2 .el-form-item__content {
  min-width: 50px !important;
}
/* 核心性能指标趋势 */
.Core_performance .el-card {
  height: 340px;
}
.Core_performance .trend_bottom {
  display: flex;
  justify-content: space-between;
}
.Core_performance .trend_bottom .el-card {
  width: 49.1%;
}
.queryReport .el-form-item__content {
  margin-right: 10px;
}
.editRecipient .el-form-item {
  margin-bottom: 15px !important;
}

.queryReport .el-select--mini {
  width: 546px !important;
}

/* .el-input {
  width: 300px;
} */
/* 注释，因为会影响其他页面, 如需使用，请添加前置class or id */
/* .el-button el-button--info el-button--mini {
  margin-left: 10px;
} */
.report-input {
  width: 300px !important;
}
/* .el-form-item__label {
  line-height: 40px !important;
} */
.editBtn {
  margin-right: 10px;
}
.gameTable1 {
  width: 100%;
  font-size: 13px;
}
.gameTable1 td {
  border: 1px solid #e2e7eb;
  height: 31px;
  white-space: nowrap;
  text-align: center;
}
.memory_width_selec .el-input--mini .el-input__inner {
  width: 120px;
}
.dialogForm .el-form--label-top .el-form-item__label {
  padding: 0 !important;
}
.dialogForm .el-form-item {
  margin-bottom: 10px !important;
  margin-right: 0 !important;
}
.dialogForm .el-form--inline.el-form--label-top {
  justify-content: space-between;
}
.dialogForm .el-upload-dragger,
.dialogForm .upload-demo,
.dialogForm .el-upload {
  width: 100% !important;
}
.dialogForm .el-upload__tip {
  margin: 0 !important;
}
.memory_version_input .el-input__inner {
  width: 37px;
  padding: 0 2px;
}
.memory_tips_input .el-input__inner {
  width: 380px;
  padding: 0 2px;
}
.dialogForm .el-dialog__header {
  padding: 20px 20px 0px !important;
}
.dialogForm .el-select {
  width: 120px;
}
</style>
